import React, { useEffect, FC } from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import AppBar from "@material-ui/core/AppBar";
import { DateTime } from "luxon";
import { CircularProgress, Select, MenuItem, Button } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import {
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ReferenceLine,
  ResponsiveContainer,
  LineChart,
  Line,
} from "recharts";
import { postRequest } from "../../../apis/axiosAction";
import KeieiShindanDialog from "../KeieiShindanDialog";
import { selectUser } from "../../../features/userSlice";
import { useDispatch, useSelector } from "react-redux";
import KeieiShindanManagerAnalysisTable from "./KeieiShindanManagerAnalysisTable";
import DatePicker from "../../common/DatePicker";
import { zonedTimeToUtc } from "date-fns-tz";
import { userLogging } from "../../../apis/userLog";
import { getFirestoreDocData } from "../../../apis/firestoreAction";
import KeieiShindanStoreScoreDataButton from "./KeieiShindanStoreScoreDataButton";
import {
  sendKeieiShindanDoAllStoreAnalysisAccessLog,
  sendKeieiShindanStoreAnalysisAccessLog,
} from "../../../apis/accessLogService";
import { ANALYSIS_TYPES } from "../../TenpoCheck/constants";
import {
  isDownloadPointData,
  isDmCheck,
  hasManagerAnalysisFullReferencePrivileges,
  isZmCheck,
} from "../../../apis/privilege";
import {
  updateKeieiShindanManagerOldTab,
  updateKeieiShindanManagerOldMap,
} from "../../organisms/search/TenpoCheckSearchSlice";
import { getKeieiShindanMaxScore } from "../Register/KeieiShindanDataOperation";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    height: "70vh",
    width: "90vw",
    margin: "auto",
    // iPad縦
    "@media (min-width: 830px)": {
      height: "65vh",
    },
    // iPad横
    "@media (min-width: 1100px)": {
      height: "70vh",
    },
    // GWPC
    "@media (min-width: 1300px)": {
      height: "70vh",
    },
  },
  graphTable: {
    maxWidth: "80vw",
    backgroundColor: "#ffffff",
    border: "none",
    marginTop: "10px",
    marginBottom: "5px",
  },
  overLayer: {
    position: "fixed",
    width: "100%",
    height: "100%",
    top: "0",
    left: "0",
    backgroundColor: "#CCC",
    opacity: "0.5",
    zIndex: 100000,
  },
  circularProgress: {
    position: "absolute",
    top: "35%",
    left: "45%",
    opacity: "0.8",
    color: "#ccc",
    zIndex: 99999,
  },
}));

// グラフの色リスト
const fillCodeList = [
  "#8884d8",
  "#82ca9d",
  "skyblue",
  "coral",
  "peru",
  "plum",
  "gold",
  "pink",
  "blue",
  "red",
];
const tableHeaderList2 = [
  { name: "基本四原則", max_score: "30" },
  { name: "従業員募集・定着", max_score: "24" },
  { name: "体制強化", max_score: "24" },
  { name: "行為計画", max_score: "22" },
  { name: "労使関連 遵守項目", max_score: "0" },
  { name: "声掛け人数", max_score: "" },
];

const initSmallTitleKoekake: any[] = [{ id: 1, name: "-" }];
const smallTitleKoekake: any[] = [
  { id: 1, name: "項目を選択" },
  { id: 2, name: "従業員人数" },
  { id: 3, name: "早朝" },
  { id: 4, name: "午前" },
  { id: 5, name: "午後" },
  { id: 6, name: "夕方" },
  { id: 7, name: "深夜" },
  { id: 8, name: "合計" },
];
const ITEM_ALL_VALUE = "1";
const ITEM_1_VALUE = "2";
const ITEM_2_VALUE = "3";
const ITEM_3_VALUE = "4";
const ITEM_4_VALUE = "5";
const ITEM_5_VALUE = "6";
const ITEM_6_VALUE = "7";
const JUNSHU_BIG_ITEM_ID = "6";
const KOEKAKE_BIG_ITEM_ID = "9";
const SMALL_ITEM_ALL_VALUE = "1";
const TAB_ZO_VALUE = 0;
const TAB_DO_VALUE = 1;
const TAB_OFC_VALUE = 2;
const TAB_KOTEN_VALUE = 3;
const initSmallTitle: any = { id: 1, name: "全体", max_score: "" };

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

// 実行結果
const AnalysisResult: FC<{
  zoCode: string;
  doCode: string;
  baseData: DateTime | null;
  update: boolean;
  analysis: number;
  initTabValue: number;
  initTableMap: any;
}> = ({
  zoCode,
  doCode,
  baseData,
  update,
  analysis,
  initTabValue,
  initTableMap,
}) => {
  const classes = useStyles();
  const user = useSelector(selectUser);
  const [tabValue, setTabValue] = React.useState(
    initTabValue ? initTabValue : 0
  );
  const dispatch = useDispatch();
  const [indexTabValue, setIndexTabValue] = React.useState(
    initTabValue ? initTabValue : 0
  );

  const [targetData, setTargetData] = React.useState<any[]>();
  const [targetGraphData, setTargetGraphData] = React.useState<any[]>();
  const [targetData0, setTargetData0] = React.useState<any[]>([]);
  const [targetData1, setTargetData1] = React.useState<any[]>([]);
  const [targetData2, setTargetData2] = React.useState<any[]>([]);
  const [targetData3, setTargetData3] = React.useState<any[]>([]);
  const [targetData4, setTargetData4] = React.useState<any[]>([]);
  const [targetData5, setTargetData5] = React.useState<any[]>([]);
  const [targetData6, setTargetData6] = React.useState<any[]>([]);
  const [targetSmallData, setTargetSmallData] = React.useState<any[]>([]);
  const [targetSmallAverageData, setTargetSmallAverageData] =
    React.useState<any>({});

  const [targetAverageData, setTargetAverageData] = React.useState<any>({});
  const [targetAverageData0, setTargetAverageData0] = React.useState<any>({});
  const [targetAverageData1, setTargetAverageData1] = React.useState<any>({});
  const [targetAverageData2, setTargetAverageData2] = React.useState<any>({});
  const [targetAverageData3, setTargetAverageData3] = React.useState<any>({});
  const [targetAverageData4, setTargetAverageData4] = React.useState<any>({});
  const [targetAverageData5, setTargetAverageData5] = React.useState<any>({});
  const [targetAverageData6, setTargetAverageData6] = React.useState<any>({});

  const [graphUserList, setGraphUserList] = React.useState<any[]>([]);

  const [workZoCode, setWorkZoCode] = React.useState(zoCode);
  const [workDoCode, setWorkDoCode] = React.useState(doCode);
  const [ofcId, setOfcId] = React.useState("");
  const [tenpoCode, setTenpoCode] = React.useState("");
  const [executeFlg, setExecuteFlg] = React.useState("");
  const [initFlg, setInigFlg] = React.useState(true);
  const [updateFlg, setUpdateFlg] = React.useState(true);
  const [workBaseData, setWorkBaseData] = React.useState(baseData);
  const [dialogMessage, setDialogMessage] = React.useState<any[]>([]);
  const [dialogFlg, setDialogFlg] = React.useState(false);
  const [zoTabDisableFlg, setZoTabDisableFlg] = React.useState(true);
  const [doTabDisableFlg, setDoTabDisableFlg] = React.useState(true);
  const [ofcTabDisableFlg, setOfcTabDisableFlg] = React.useState(true);
  const [kobetuTabDisableFlg, setKobetuTabDisableFlg] = React.useState(true);

  const [tableHeaderList, setTableHeaderList] = React.useState<any[]>([]);
  const [headerName, setHeaderName] = React.useState("");
  const [tableSubmissionHeaderList, setTableSubmissionHeaderList] =
    React.useState<string[]>([]);

  const [tableList, setTableList] = React.useState<any[]>([
    { id: 1, name: "総合" },
  ]);
  const [smallTitleList1, setSmallTitleList1] = React.useState<any[]>([]);
  const [smallTitleList2, setSmallTitleList2] = React.useState<any[]>([]);
  const [smallTitleList3, setSmallTitleList3] = React.useState<any[]>([]);
  const [smallTitleList4, setSmallTitleList4] = React.useState<any[]>([]);
  const [smallTitleList5, setSmallTitleList5] = React.useState<any[]>([]);
  const [smallTitleList, setSmallTitleList] = React.useState<any[]>([
    initSmallTitle,
  ]);
  const [selectedSmallFlg, setSelectedSmallFlg] = React.useState(false);
  const [templateItemList, setTemplateItemList] = React.useState<any[]>([]);
  const [templateSmallItemList, setTemplateSmallItemList] = React.useState<
    any[]
  >([]);
  const [templatesMap, setTemplatesMap] = React.useState<any>({});

  const [selectedTable, setSelectedTable] = React.useState(ITEM_ALL_VALUE);
  const [selectedSmallTitle, setSelectedSmallTitle] =
    React.useState(SMALL_ITEM_ALL_VALUE);

  const [selectedBaseDate, setSelectedBaseDate] =
    React.useState<DateTime | null>(null);
  const [selectedSmallBaseDate, setSelectedSmallBaseDate] =
    React.useState<DateTime | null>(null);
  const [baseMonth, setBaseMonth] = React.useState<string>("");
  const [smallBaseMonth, setSmallBaseMonth] = React.useState<string>("");

  const [allDoFlg, setAllDoFlg] = React.useState(false);

  const [tmpInitTableMap, setTmpInitTableMap] = React.useState<any>({});
  const [maxScoreDisplay, setMaxScoreDisplay] = React.useState<any>("");

  const cloneList = (list: any) => {
    let newList: any[] = [];
    for (const item of list) {
      newList.push(item);
    }
    return newList;
  };
  const cloneListMap = (list: any) => {
    let newList: any[] = [];
    for (const map of list) {
      newList.push(cloneMap(map));
    }
    return newList;
  };
  const cloneMap = (map: any) => {
    let newMap: any = {};
    Object.keys(map).forEach(function (key) {
      newMap[key] = map[key];
    });
    return newMap;
  };
  // データ取得用useEffect
  useEffect(() => {
    changeTitles(tabValue);
    getSmallTitles();
    // getTemplateTitles();
    if (initFlg) {
      userLogging("KeieiShindan", "管理者分析#初期表示", "");
      setInigFlg(false);

      if (initTabValue && initTableMap) {
        let initSelectedTable: string = initTableMap["selectedTable"];
        setSelectedTable(initSelectedTable);
        setSelectedSmallTitle(initTableMap["selectedSmallTable"]);

        let initTargetDataMap = cloneListMap(initTableMap["targetList0"]);
        let initTargetAverageData = cloneMap(
          initTableMap["targetAverageData0"]
        );

        switch (initSelectedTable) {
          case ITEM_ALL_VALUE:
            initTargetDataMap = cloneListMap(initTableMap["targetList0"]);
            initTargetAverageData = cloneMap(
              initTableMap["targetAverageData0"]
            );
            break;
          case ITEM_1_VALUE:
            initTargetDataMap = cloneListMap(initTableMap["targetList1"]);
            initTargetAverageData = cloneMap(
              initTableMap["targetAverageData1"]
            );
            break;
          case ITEM_2_VALUE:
            initTargetDataMap = cloneListMap(initTableMap["targetList2"]);
            initTargetAverageData = cloneMap(
              initTableMap["targetAverageData2"]
            );
            break;
          case ITEM_3_VALUE:
            initTargetDataMap = cloneListMap(initTableMap["targetList3"]);
            initTargetAverageData = cloneMap(
              initTableMap["targetAverageData3"]
            );
            break;
          case ITEM_4_VALUE:
            initTargetDataMap = cloneListMap(initTableMap["targetList4"]);
            initTargetAverageData = cloneMap(
              initTableMap["targetAverageData4"]
            );
            break;
          case ITEM_5_VALUE:
            initTargetDataMap = cloneListMap(initTableMap["targetList5"]);
            initTargetAverageData = cloneMap(
              initTableMap["targetAverageData5"]
            );
            break;
        }

        setSmallTitleList([initSmallTitle]);
        if (initTableMap["smallTitleList"]) {
          setSmallTitleList(cloneList(initTableMap["smallTitleList"]));
        }

        if (initTableMap["selectedSmallFlg"]) {
          setSelectedSmallFlg(initTableMap["selectedSmallFlg"]);
          setTargetSmallData(cloneListMap(initTableMap["targetSmallData"]));
          setTargetSmallAverageData(
            cloneMap(initTableMap["targetSmallAverageData"])
          );
          setTemplateSmallItemList(
            cloneListMap(initTableMap["templateSmallItemList"])
          );
          let selectedSmallDate = initTableMap["selectedSmallBaseDate"];
          if (selectedSmallDate) {
            let smallBaseDateTime = DateTime.fromFormat(
              selectedSmallDate,
              "yyyyMMdd"
            );
            setSelectedSmallBaseDate(smallBaseDateTime);
            setSmallBaseMonth(
              getFirstDayOfWeek(smallBaseDateTime.toFormat("yyyyMMdd"), 0)
            );
          }
        }

        setTargetData(initTargetDataMap);
        setTargetAverageData(initTargetAverageData);

        setTargetData0(cloneListMap(initTableMap["targetList0"]));
        setTargetData1(cloneListMap(initTableMap["targetList1"]));
        setTargetData2(cloneListMap(initTableMap["targetList2"]));
        setTargetData3(cloneListMap(initTableMap["targetList3"]));
        setTargetData4(cloneListMap(initTableMap["targetList4"]));
        setTargetData5(cloneListMap(initTableMap["targetList5"]));
        setTargetData6(cloneListMap(initTableMap["targetList6"]));

        setTargetAverageData(cloneMap(initTableMap["targetAverageData0"]));
        setTargetAverageData0(cloneMap(initTableMap["targetAverageData0"]));
        setTargetAverageData1(cloneMap(initTableMap["targetAverageData1"]));
        setTargetAverageData2(cloneMap(initTableMap["targetAverageData2"]));
        setTargetAverageData3(cloneMap(initTableMap["targetAverageData3"]));
        setTargetAverageData4(cloneMap(initTableMap["targetAverageData4"]));
        setTargetAverageData5(cloneMap(initTableMap["targetAverageData5"]));
        setTargetAverageData6(cloneMap(initTableMap["targetAverageData6"]));
        setTableSubmissionHeaderList(initTableMap["tableSubmissionHeaderList"]);
        setTableHeaderList(initTableMap["tableHeaderList"]);
        setTableList(initTableMap["tableList"]);
        let initWorkZoCode = initTableMap["workZoCode"];
        let initWorkDoCode = initTableMap["workDoCode"];
        let initWorkOfcId = initTableMap["ofcId"];
        setWorkZoCode(initWorkZoCode);
        setWorkDoCode(initWorkDoCode);
        setOfcId(initWorkOfcId);
        setMaxScoreDisplay(initTableMap["maxScore"]);
        setTenpoCode(initTableMap["tenpoCode"]);
        setTemplateItemList(cloneListMap(initTableMap["templateItemList"]));
        setTemplatesMap(cloneMap(initTableMap["templatesMap"]));
        setTemplateSmallItemList(
          cloneListMap(initTableMap["templateSmallItemList"])
        );
        setAllDoFlg(initTableMap["allDoFlg"]);
        setIndexTabValue(initTableMap["indexTabValue"]);
        let selectedDate = initTableMap["selectedBaseDate"];
        if (selectedDate) {
          let baseDateTime = DateTime.fromFormat(selectedDate, "yyyyMMdd");
          setSelectedBaseDate(baseDateTime);
          setBaseMonth(getFirstDayOfWeek(baseDateTime.toFormat("yyyyMMdd"), 0));
        }
        updateDisableTabInit(initWorkZoCode, initWorkDoCode, initWorkOfcId);
        changeGraphData(
          initTargetDataMap,
          initTableMap["tableHeaderList"],
          initTargetAverageData
        );

        setTmpInitTableMap(cloneMap(initTableMap));
        return;
      }

      // admin-groupの場合のみ初回読み込み時に全検索を行う
      if (!hasManagerAnalysisFullReferencePrivileges(user)) {
        if (isZmCheck(user)) {
          changeTitles(1);
        }
        if (isDmCheck(user)) {
          changeTitles(2);
        }
        return;
      }
    }

    userLogging(
      "KeieiShindan",
      "管理者分析#データ取得条件",
      "タブ名[" +
        headerName +
        "別分析] ZO[" +
        workZoCode +
        "] DO[" +
        workDoCode +
        "] データ[" +
        workBaseData +
        "] OFC[" +
        ofcId +
        "] 店舗[" +
        tenpoCode +
        "]"
    );
    getTableData(
      String(tabValue + 1),
      workZoCode,
      workDoCode,
      workBaseData || DateTime.local(),
      ofcId,
      tenpoCode
    ).then((res: any) => {
      changeTitles(tabValue);
      let responseMap: any = res;
      userLogging(
        "KeieiShindan",
        "管理者分析#データ取得結果",
        JSON.stringify(responseMap)
      );
      if (responseMap) {
        setTargetData(responseMap.dataList);
      }
      updateDisableTab();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabValue, updateFlg]);

  // 詳細項目一覧取得
  const getSmallTitles = () => {
    getFirestoreDocData("keiei_shindan_items", "000000_basedata").then(
      (response: any) => {
        let initItem = initSmallTitle;
        let smallItems1: any[] = [initItem];
        let smallItems2: any[] = [initItem];
        let smallItems3: any[] = [initItem];
        let smallItems4: any[] = [initItem];
        let smallItems5: any[] = [initItem];

        Object.keys(response.attribution)
          .sort()
          .forEach(function (key) {
            let smallItems: any[] = response.attribution[key].small_items;
            let bigItemId = response.attribution[key].big_item_id;
            for (const row of smallItems) {
              let id = Number(row.id) + 1;
              let name = row.name;
              let maxScore = 0;
              if (row.score_list) {
                maxScore = Number(row.score_list[0]);
              }
              if (bigItemId === "1")
                smallItems1.push({ id: id, name: name, max_score: maxScore });
              if (bigItemId === "2")
                smallItems2.push({ id: id, name: name, max_score: maxScore });
              if (bigItemId === "3")
                smallItems3.push({ id: id, name: name, max_score: maxScore });
              if (bigItemId === "4")
                smallItems4.push({ id: id, name: name, max_score: maxScore });
              if (bigItemId === "5")
                smallItems5.push({ id: id, name: name, max_score: maxScore });
              if (bigItemId === "6")
                smallItems5.push({
                  id: id + 100,
                  name: name,
                  max_score: maxScore,
                });
            }
          });
        setSmallTitleList1(smallItems1);
        setSmallTitleList2(smallItems2);
        setSmallTitleList3(smallItems3);
        setSmallTitleList4(smallItems4);
        setSmallTitleList5(smallItems5);
        return;
      }
    );
  };

  // 実行ボタン押下時用useEffect
  useEffect(() => {
    if (initTabValue !== 0 && initFlg) {
      return;
    }
    setTabValue(analysis);
    setIndexTabValue(analysis);
    if (isZmCheck(user)) {
      setIndexTabValue(analysis - 1);
    }
    if (isDmCheck(user)) {
      setIndexTabValue(analysis - 2);
    }
    if (zoCode !== "") {
      setWorkZoCode(zoCode);
    }
    if (doCode !== "") {
      setWorkDoCode(doCode);
    }
    // setOfcId("");
    // setTenpoCode("");
    setUpdateFlg(update);
    setWorkBaseData(baseData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [update]);

  // 表示するヘッダ名の変更
  const changeTitles = (num: number) => {
    if (num === TAB_ZO_VALUE) {
      setHeaderName("ZO");
    }
    if (num === TAB_DO_VALUE) {
      setHeaderName("DO");
    }
    if (num === TAB_OFC_VALUE) {
      setHeaderName("OFC");
    }
    if (num === TAB_KOTEN_VALUE) {
      setHeaderName("個店");
    }
  };

  //  タブのクリック処理
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setIndexTabValue(newValue);
    setMaxScoreDisplay("");
    if (isZmCheck(user)) {
      newValue = newValue + 1;
    }
    if (isDmCheck(user)) {
      newValue = newValue + 2;
    }

    changeTitles(newValue);
    setTabValue(newValue);
  };

  const dialogClose = () => {
    setDialogFlg(false);
  };

  // タブの活性・非活性更新
  function updateDisableTab() {
    if (hasManagerAnalysisFullReferencePrivileges(user)) {
      setZoTabDisableFlg(false);
    }
    setDoTabDisableFlg(workZoCode ? false : true);
    setOfcTabDisableFlg(workDoCode ? false : true);
    setKobetuTabDisableFlg(ofcId ? false : true);
  }
  function updateDisableTabInit(
    initWorkZoCode: string,
    initWorkDoCode: string,
    initOfcId: string
  ) {
    if (hasManagerAnalysisFullReferencePrivileges(user)) {
      setZoTabDisableFlg(false);
    }
    setDoTabDisableFlg(initWorkZoCode ? false : true);
    setOfcTabDisableFlg(initWorkDoCode ? false : true);
    setKobetuTabDisableFlg(initOfcId ? false : true);
  }

  // 平均点計算
  function calcAverage(num: any, count: any) {
    if (!num) {
      return 0;
    }
    return Math.round(parseFloat(num) / parseFloat(count));
  }

  // パーセント計算
  function calcPercent(num: any, count: any) {
    if (!num) {
      return 0;
    }
    return Math.round((parseFloat(num) / parseFloat(count)) * 100);
  }
  // 差分計算
  function calcDiff(num1: any, num2: any) {
    let mainScore: number = Number(num1) || 0;
    let diffScore: number = Number(num2) || 0;
    let result: number = 0;
    result = Math.round(mainScore) - Math.round(diffScore);
    result = Math.round(result);

    return result;
  }
  // コード順に並べ変え
  function sortCode(dataMapList: any[]) {
    let mapList: any[] = dataMapList;

    if (tabValue === TAB_OFC_VALUE) {
      return mapList.sort(function (first, second) {
        if (first.sortDoCode > second.sortDoCode) {
          return 1;
        } else if (first.sortDoCode < second.sortDoCode) {
          return -1;
        } else {
          if (first.sortOfcCode > second.sortOfcCode) {
            return 1;
          } else if (first.sortOfcCode < second.sortOfcCode) {
            return -1;
          } else {
            return 0;
          }
        }
      });
    } else if (tabValue === TAB_KOTEN_VALUE) {
      return mapList.sort(function (first, second) {
        if (first.sortOfcCode > second.sortOfcCode) {
          return 1;
        } else if (first.sortOfcCode < second.sortOfcCode) {
          return -1;
        } else {
          if (first.code > second.code) {
            return 1;
          } else if (first.code < second.code) {
            return -1;
          } else {
            return 0;
          }
        }
      });
    } else {
      return mapList.sort(function (first, second) {
        if (first.code > second.code) {
          return 1;
        } else if (first.code < second.code) {
          return -1;
        } else {
          return 0;
        }
      });
    }
  }
  // 総数計算の対象判断
  const countTotalTarget = (score: any) => {
    let value: number = Number(score);
    if (value === 0) {
      return 0;
    } else {
      return 1;
    }
  };
  // 小数点以下を四捨五入
  const roundOffDecimal = (num: any) => {
    let value: number = Number(num);
    if (value) {
      return Math.round(value);
    }
    return 0;
  };

  // データ取得(API)
  const getData = (
    analysis: string,
    zoCode: string,
    doCode: string,
    target_date: DateTime,
    ofc_id: string,
    tenpo_code: string
  ) => {
    let workAnalysis = String(analysis);
    if (allDoFlg && workAnalysis === "4") {
      workAnalysis = "5";
    }

    // アクセスログ送信
    if (workAnalysis === ANALYSIS_TYPES.DO_STORE_ANALYSIS) {
      sendKeieiShindanDoAllStoreAnalysisAccessLog();
    } else if (workAnalysis === ANALYSIS_TYPES.STORE_ANALYSIS) {
      sendKeieiShindanStoreAnalysisAccessLog();
    }

    const apiParams = {
      "api-name": "analysis",
      target_date: target_date.toFormat("yyyy/MM/dd HH:mm:ss"),
      zo_code: workZoCode,
      do_code: workDoCode,
      ofc_id: ofc_id,
      tenpo_code: tenpo_code,
      analysis: workAnalysis,
    };

    let selectList: any[] = [];
    selectList.push({ id: 1, name: "総合" });
    for (let i = 0; i < tableHeaderList2.length; i++) {
      selectList.push({
        id: i + 2,
        name: tableHeaderList2[i].name,
        max_score: tableHeaderList2[i].max_score,
      });
    }
    setTableList(selectList);
    setExecuteFlg("1");
    const url = process.env.REACT_APP_API_URL_J11SPB22 + "keieishindan/analysis";
    return postRequest(url, apiParams)
      .then((res) => {
        let dataList: any[] = res.data.dataList;
        let dispatchDateMap: any = {};

        setSelectedBaseDate(null);
        setSelectedSmallBaseDate(null);
        setBaseMonth("");
        setSmallBaseMonth("");
        if (dataList) {
          // 画面入力初期化
          setGraphUserList([]);
          setSelectedTable(ITEM_ALL_VALUE);
          setSelectedSmallTitle(SMALL_ITEM_ALL_VALUE);
          setSmallTitleList([initSmallTitle]);
          setSelectedSmallFlg(false);
          for (let i = 0; i < dataList.length; i++) {
            let datajsList: any = dataList[i];
            let averageScoreBreakdown: any[] =
              datajsList.average_score_breakdown;

            let monthValue: any = datajsList.month_value[0].month;
            let submissionMonthValue: any =
              datajsList.month_value[0].submission_month;
            let headerList = [];
            // 合計値用インターフェイス
            interface totalMap {
              "1w": number;
              "2w": number;
              "3w": number;
              "4w": number;
              "5w": number;
              "6w": number;
              "1wReal": number;
              "2wReal": number;
              "3wReal": number;
              "4wReal": number;
              "5wReal": number;
              "6wReal": number;
            }
            const initTotalMap = () => {
              let map: totalMap = {
                "1w": 0,
                "2w": 0,
                "3w": 0,
                "4w": 0,
                "5w": 0,
                "6w": 0,
                "1wReal": 0,
                "2wReal": 0,
                "3wReal": 0,
                "4wReal": 0,
                "5wReal": 0,
                "6wReal": 0,
              };
              return map;
            };
            // 合計値加算
            const addTotals = (
              map: totalMap,
              num1: any,
              num2: any,
              num3: any,
              num4: any,
              num5: any,
              realNum1: any,
              realNum2: any,
              realNum3: any,
              realNum4: any,
              realNum5: any
            ) => {
              map["1w"] += roundOffDecimal(num1);
              map["2w"] += roundOffDecimal(num2);
              map["3w"] += roundOffDecimal(num3);
              map["4w"] += roundOffDecimal(num4);
              map["5w"] += roundOffDecimal(num5);
              // 実点数
              map["1wReal"] += roundOffDecimal(realNum1);
              map["2wReal"] += roundOffDecimal(realNum2);
              map["3wReal"] += roundOffDecimal(realNum3);
              map["4wReal"] += roundOffDecimal(realNum4);
              map["5wReal"] += roundOffDecimal(realNum5);
            };
            // 地区平均の作成
            const makeAverage = (
              totalScore: totalMap,
              countList: number[],
              headerList: any[]
            ) => {
              let averageMap: any = {
                name: "地区平均／" + averageTitle + "平均",
                code: "average",
              };
              // totalには5～1が逆に入っている 6は別
              let average1 = calcAverage(totalScore["1w"], countList[0]);
              let average2 = calcAverage(totalScore["2w"], countList[1]);
              let average3 = calcAverage(totalScore["3w"], countList[2]);
              let average4 = calcAverage(totalScore["4w"], countList[3]);
              let average5 = calcAverage(totalScore["5w"], countList[4]);
              let average6 = calcAverage(totalScore["6w"], countList[5]);
              let realAverage1 = calcAverage(
                totalScore["1wReal"],
                countList[0]
              );
              let realAverage2 = calcAverage(
                totalScore["2wReal"],
                countList[1]
              );
              let realAverage3 = calcAverage(
                totalScore["3wReal"],
                countList[2]
              );
              let realAverage4 = calcAverage(
                totalScore["4wReal"],
                countList[3]
              );
              let realAverage5 = calcAverage(
                totalScore["5wReal"],
                countList[4]
              );
              let realAverage6 = calcAverage(
                totalScore["6wReal"],
                countList[5]
              );

              averageMap[headerList[0]] = average1;
              averageMap[headerList[1]] = average2;
              averageMap[headerList[2]] = average3;
              averageMap[headerList[3]] = average4;
              averageMap[headerList[4]] = average5;
              averageMap["1wDiff"] = calcDiff(average1, average6);
              averageMap["2wDiff"] = calcDiff(average2, average1);
              averageMap["3wDiff"] = calcDiff(average3, average2);
              averageMap["4wDiff"] = calcDiff(average4, average3);
              averageMap["5wDiff"] = calcDiff(average5, average4);
              averageMap[headerList[0] + "Real"] = realAverage1;
              averageMap[headerList[1] + "Real"] = realAverage2;
              averageMap[headerList[2] + "Real"] = realAverage3;
              averageMap[headerList[3] + "Real"] = realAverage4;
              averageMap[headerList[4] + "Real"] = realAverage5;
              averageMap["1wDiffReal"] = calcDiff(realAverage1, realAverage6);
              averageMap["2wDiffReal"] = calcDiff(realAverage2, realAverage1);
              averageMap["3wDiffReal"] = calcDiff(realAverage3, realAverage2);
              averageMap["4wDiffReal"] = calcDiff(realAverage4, realAverage3);
              averageMap["5wDiffReal"] = calcDiff(realAverage5, realAverage4);
              return averageMap;
            };

            const dataMapCreate = (
              dataMap: any,
              headerList: any[],
              no: number,
              resultMap: any
            ) => {
              let map: any = {
                name: dataMap.name,
                code: dataMap.code,
                sortDoCode: dataMap.sortDoCode,
                sortOfcCode: dataMap.sortOfcCode,
                ofcName: dataMap.ofcName,
              };

              map[headerList[4]] = roundOffDecimal(
                resultMap.result1["score" + no]
              );
              map[headerList[3]] = roundOffDecimal(
                resultMap.result2["score" + no]
              );
              map[headerList[2]] = roundOffDecimal(
                resultMap.result3["score" + no]
              );
              map[headerList[1]] = roundOffDecimal(
                resultMap.result4["score" + no]
              );
              map[headerList[0]] = roundOffDecimal(
                resultMap.result5["score" + no]
              );
              map["5wDiff"] = calcDiff(
                resultMap.result1["score" + no],
                resultMap.result2["score" + no]
              );
              map["4wDiff"] = calcDiff(
                resultMap.result2["score" + no],
                resultMap.result3["score" + no]
              );
              map["3wDiff"] = calcDiff(
                resultMap.result3["score" + no],
                resultMap.result4["score" + no]
              );
              map["2wDiff"] = calcDiff(
                resultMap.result4["score" + no],
                resultMap.result5["score" + no]
              );
              map["1wDiff"] = calcDiff(
                resultMap.result5["score" + no],
                resultMap.result6["score" + no]
              );

              // 実点数
              map[headerList[4] + "Real"] = roundOffDecimal(
                resultMap.result1["real_score" + no]
              );
              map[headerList[3] + "Real"] = roundOffDecimal(
                resultMap.result2["real_score" + no]
              );
              map[headerList[2] + "Real"] = roundOffDecimal(
                resultMap.result3["real_score" + no]
              );
              map[headerList[1] + "Real"] = roundOffDecimal(
                resultMap.result4["real_score" + no]
              );
              map[headerList[0] + "Real"] = roundOffDecimal(
                resultMap.result5["real_score" + no]
              );
              map["5wDiffReal"] = calcDiff(
                resultMap.result1["real_score" + no],
                resultMap.result2["real_score" + no]
              );
              map["4wDiffReal"] = calcDiff(
                resultMap.result2["real_score" + no],
                resultMap.result3["real_score" + no]
              );
              map["3wDiffReal"] = calcDiff(
                resultMap.result3["real_score" + no],
                resultMap.result4["real_score" + no]
              );
              map["2wDiffReal"] = calcDiff(
                resultMap.result4["real_score" + no],
                resultMap.result5["real_score" + no]
              );
              map["1wDiffReal"] = calcDiff(
                resultMap.result5["real_score" + no],
                resultMap.result6["real_score" + no]
              );
              return map;
            };

            // 月名称の設定
            if (monthValue) {
              headerList.push(monthValue.month5);
              headerList.push(monthValue.month4);
              headerList.push(monthValue.month3);
              headerList.push(monthValue.month2);
              headerList.push(monthValue.month1);

              setTableHeaderList(headerList);
              dispatchDateMap["tableHeaderList"] = headerList;
            }
            // 提出数用月
            if (submissionMonthValue) {
              let list: string[] = [];
              list.push(submissionMonthValue.month5);
              list.push(submissionMonthValue.month4);
              list.push(submissionMonthValue.month3);
              list.push(submissionMonthValue.month2);
              list.push(submissionMonthValue.month1);
              setTableSubmissionHeaderList(list);
              dispatchDateMap["tableSubmissionHeaderList"] = list;
            }

            // 統合の設定
            let averageTitle = "";
            if (tabValue === TAB_ZO_VALUE) {
              averageTitle = "ZO";
            } else if (tabValue === TAB_DO_VALUE) {
              averageTitle = "DO";
            } else if (tabValue === TAB_OFC_VALUE) {
              averageTitle = "OFC";
            } else if (tabValue === TAB_KOTEN_VALUE) {
              averageTitle = "個別";
            }
            let totalScore0: totalMap = initTotalMap();
            let month1Count = 0;
            let month2Count = 0;
            let month3Count = 0;
            let month4Count = 0;
            let month5Count = 0;
            let month6Count = 0;

            // 項目別の設定
            let scoreList0: any[] = [];
            let scoreList1: any[] = [];
            let scoreList2: any[] = [];
            let scoreList3: any[] = [];
            let scoreList4: any[] = [];
            let scoreList5: any[] = [];
            let scoreList6: any[] = [];
            let totalScore1: totalMap = initTotalMap();
            let totalScore2: totalMap = initTotalMap();
            let totalScore3: totalMap = initTotalMap();
            let totalScore4: totalMap = initTotalMap();
            let totalScore5: totalMap = initTotalMap();
            let totalScore6: totalMap = initTotalMap();

            for (let j = 0; j < averageScoreBreakdown.length; j++) {
              let name = averageScoreBreakdown[j].codeName.name;
              let code = averageScoreBreakdown[j].codeName.code;
              let sortDoCode = averageScoreBreakdown[j].codeName.sort_docode;
              let sortOfcCode = averageScoreBreakdown[j].codeName.sort_ofc_code;
              let ofcName = averageScoreBreakdown[j].codeName.ofc_name;
              const submissionMonth = averageScoreBreakdown[j].submissionMonth;

              let result1 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result1
                  ? averageScoreBreakdown[j].result1
                  : "";
              let result2 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result2
                  ? averageScoreBreakdown[j].result2
                  : "";
              let result3 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result3
                  ? averageScoreBreakdown[j].result3
                  : "";
              let result4 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result4
                  ? averageScoreBreakdown[j].result4
                  : "";
              let result5 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result5
                  ? averageScoreBreakdown[j].result5
                  : "";
              let result6 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result6
                  ? averageScoreBreakdown[j].result6
                  : "";
              let map: any = { name, code, sortDoCode, sortOfcCode, ofcName };
              let resultMap = {
                result1,
                result2,
                result3,
                result4,
                result5,
                result6,
              };

              month1Count += countTotalTarget(result5.recordCount1);
              month2Count += countTotalTarget(result4.recordCount1);
              month3Count += countTotalTarget(result3.recordCount1);
              month4Count += countTotalTarget(result2.recordCount1);
              month5Count += countTotalTarget(result1.recordCount1);
              month6Count += countTotalTarget(result6.recordCount1);

              addTotals(
                totalScore0,
                result5.score0,
                result4.score0,
                result3.score0,
                result2.score0,
                result1.score0,
                result5.real_score0,
                result4.real_score0,
                result3.real_score0,
                result2.real_score0,
                result1.real_score0
              );
              addTotals(
                totalScore1,
                result5.score1,
                result4.score1,
                result3.score1,
                result2.score1,
                result1.score1,
                result5.real_score1,
                result4.real_score1,
                result3.real_score1,
                result2.real_score1,
                result1.real_score1
              );
              addTotals(
                totalScore2,
                result5.score2,
                result4.score2,
                result3.score2,
                result2.score2,
                result1.score2,
                result5.real_score2,
                result4.real_score2,
                result3.real_score2,
                result2.real_score2,
                result1.real_score2
              );
              addTotals(
                totalScore3,
                result5.score3,
                result4.score3,
                result3.score3,
                result2.score3,
                result1.score3,
                result5.real_score3,
                result4.real_score3,
                result3.real_score3,
                result2.real_score3,
                result1.real_score3
              );
              addTotals(
                totalScore4,
                result5.score4,
                result4.score4,
                result3.score4,
                result2.score4,
                result1.score4,
                result5.real_score4,
                result4.real_score4,
                result3.real_score4,
                result2.real_score4,
                result1.real_score4
              );
              addTotals(
                totalScore5,
                result5.score5,
                result4.score5,
                result3.score5,
                result2.score5,
                result1.score5,
                result5.real_score5,
                result4.real_score5,
                result3.real_score5,
                result2.real_score5,
                result1.real_score5
              );
              addTotals(
                totalScore6,
                result5.score6,
                result4.score6,
                result3.score6,
                result2.score6,
                result1.score6,
                result5.real_score6,
                result4.real_score6,
                result3.real_score6,
                result2.real_score6,
                result1.real_score6
              );

              if (tabValue === TAB_OFC_VALUE || tabValue === TAB_KOTEN_VALUE) {
                scoreList0.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 0, resultMap),
                    submissionMonth
                  )
                );
                scoreList1.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 1, resultMap),
                    submissionMonth
                  )
                );
                scoreList2.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 2, resultMap),
                    submissionMonth
                  )
                );
                scoreList3.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 3, resultMap),
                    submissionMonth
                  )
                );
                scoreList4.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 4, resultMap),
                    submissionMonth
                  )
                );
                scoreList5.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 5, resultMap),
                    submissionMonth
                  )
                );
                scoreList6.push(
                  Object.assign(
                    dataMapCreate(map, headerList, 6, resultMap),
                    submissionMonth
                  )
                );
              } else {
                scoreList0.push(dataMapCreate(map, headerList, 0, resultMap));
                scoreList1.push(dataMapCreate(map, headerList, 1, resultMap));
                scoreList2.push(dataMapCreate(map, headerList, 2, resultMap));
                scoreList3.push(dataMapCreate(map, headerList, 3, resultMap));
                scoreList4.push(dataMapCreate(map, headerList, 4, resultMap));
                scoreList5.push(dataMapCreate(map, headerList, 5, resultMap));
                scoreList6.push(dataMapCreate(map, headerList, 6, resultMap));
              }
            }

            // 統合の地区平均
            let countList: any[] = [];
            countList.push(month1Count);
            countList.push(month2Count);
            countList.push(month3Count);
            countList.push(month4Count);
            countList.push(month5Count);
            countList.push(month6Count);
            // 地区平均
            let averageMap0 = makeAverage(totalScore0, countList, headerList);
            let averageMap1 = makeAverage(totalScore1, countList, headerList);
            let averageMap2 = makeAverage(totalScore2, countList, headerList);
            let averageMap3 = makeAverage(totalScore3, countList, headerList);
            let averageMap4 = makeAverage(totalScore4, countList, headerList);
            let averageMap5 = makeAverage(totalScore5, countList, headerList);
            let averageMap6 = makeAverage(totalScore6, countList, headerList);
            setTargetAverageData(averageMap0);
            setTargetAverageData0(averageMap0);
            setTargetAverageData1(averageMap1);
            setTargetAverageData2(averageMap2);
            setTargetAverageData3(averageMap3);
            setTargetAverageData4(averageMap4);
            setTargetAverageData5(averageMap5);
            setTargetAverageData6(averageMap6);

            setTargetData0(sortCode(scoreList0));
            setTargetData1(sortCode(scoreList1));
            setTargetData2(sortCode(scoreList2));
            setTargetData3(sortCode(scoreList3));
            setTargetData4(sortCode(scoreList4));
            setTargetData5(sortCode(scoreList5));
            setTargetData6(sortCode(scoreList6));

            dispatchDateMap["targetList0"] = cloneListMap(sortCode(scoreList0));
            dispatchDateMap["targetList1"] = cloneListMap(sortCode(scoreList1));
            dispatchDateMap["targetList2"] = cloneListMap(sortCode(scoreList2));
            dispatchDateMap["targetList3"] = cloneListMap(sortCode(scoreList3));
            dispatchDateMap["targetList4"] = cloneListMap(sortCode(scoreList4));
            dispatchDateMap["targetList5"] = cloneListMap(sortCode(scoreList5));
            dispatchDateMap["targetList6"] = cloneListMap(sortCode(scoreList6));
            dispatchDateMap["targetAverageData0"] = cloneMap(averageMap0);
            dispatchDateMap["targetAverageData1"] = cloneMap(averageMap1);
            dispatchDateMap["targetAverageData2"] = cloneMap(averageMap2);
            dispatchDateMap["targetAverageData3"] = cloneMap(averageMap3);
            dispatchDateMap["targetAverageData4"] = cloneMap(averageMap4);
            dispatchDateMap["targetAverageData5"] = cloneMap(averageMap5);
            dispatchDateMap["targetAverageData6"] = cloneMap(averageMap6);
            dispatchDateMap["tableList"] = selectList;
            dispatchDateMap["workZoCode"] = workZoCode;
            dispatchDateMap["workDoCode"] = workDoCode;
            dispatchDateMap["ofcId"] = ofc_id;
            dispatchDateMap["tenpoCode"] = tenpo_code;
            dispatchDateMap["templateItemList"] =
              cloneListMap(templateItemList);
            dispatchDateMap["templatesMap"] = cloneMap(templatesMap);
            dispatchDateMap["templateSmallItemList"] = cloneListMap(
              templateSmallItemList
            );
            dispatchDateMap["allDoFlg"] = allDoFlg;
            dispatchDateMap["indexTabValue"] = indexTabValue;
            dispatchDateMap["selectedTable"] = ITEM_ALL_VALUE;
            dispatchDateMap["selectedSmallTable"] = SMALL_ITEM_ALL_VALUE;
            dispatchDateMap["selectedSmallFlg"] = false;
            dispatchDateMap["workZoCode"] = workZoCode;
            dispatchDateMap["workDoCode"] = workDoCode;

            dispatch(
              updateKeieiShindanManagerOldMap({
                keieiShindanManagerMap: dispatchDateMap,
              })
            );

            dispatch(
              updateKeieiShindanManagerOldTab({
                keieiShindanManagerTab: tabValue,
              })
            );
            setTmpInitTableMap(dispatchDateMap);
            setMaxScoreDisplay("");

            return {
              monthList: scoreList0,
              headerList,
              averageMap: averageMap0,
            };
          }
        }
      })
      .catch((r) => {
        setDialogMessage([String(r)]);
        setDialogFlg(true);
      })
      .finally(() => {
        setExecuteFlg("");
      });
  };

  // グラフ用の値を補足
  const getTableData = async (
    analysis: string,
    zoCode: string,
    doCode: string,
    target_date: DateTime,
    ofc_id: string,
    tenpo_code: string
  ) => {
    let resultMap: any = {};
    let result = await getData(
      analysis,
      zoCode,
      doCode,
      target_date,
      ofc_id,
      tenpo_code
    );
    let dataList: any[] = [];
    if (result) {
      resultMap = result;
      dataList = result.monthList;
      let headerList = result.headerList;
      let averageMap = result.averageMap;
      changeGraphData(dataList, headerList, averageMap);
    }
    resultMap["dataList"] = dataList;

    return resultMap;
  };

  // グラフの設定
  function changeGraphData(
    dataList: any[],
    headerList: any[],
    averageMap: any
  ) {
    let monthMap_1: any = {};
    let monthMap_2: any = {};
    let monthMap_3: any = {};
    let monthMap_4: any = {};
    let monthMap_5: any = {};
    let graphDataList = [];

    if (dataList) {
      for (let i = 0; i < dataList.length; i++) {
        monthMap_1[dataList[i].name] = dataList[i][headerList[0]];
        monthMap_2[dataList[i].name] = dataList[i][headerList[1]];
        monthMap_3[dataList[i].name] = dataList[i][headerList[2]];
        monthMap_4[dataList[i].name] = dataList[i][headerList[3]];
        monthMap_5[dataList[i].name] = dataList[i][headerList[4]];
      }
      if (averageMap) {
        monthMap_1[averageMap.name] = averageMap[headerList[0]];
        monthMap_2[averageMap.name] = averageMap[headerList[1]];
        monthMap_3[averageMap.name] = averageMap[headerList[2]];
        monthMap_4[averageMap.name] = averageMap[headerList[3]];
        monthMap_5[averageMap.name] = averageMap[headerList[4]];
      }
    }

    for (let j = 0; j < headerList.length; j++) {
      if (j === 0) monthMap_1["month"] = headerList[j];
      if (j === 1) monthMap_2["month"] = headerList[j];
      if (j === 2) monthMap_3["month"] = headerList[j];
      if (j === 3) monthMap_4["month"] = headerList[j];
      if (j === 4) monthMap_5["month"] = headerList[j];
    }
    graphDataList.push(monthMap_1);
    graphDataList.push(monthMap_2);
    graphDataList.push(monthMap_3);
    graphDataList.push(monthMap_4);
    graphDataList.push(monthMap_5);

    setTargetGraphData(graphDataList);
  }

  // ZO名、DO名、OFC名のクリック
  const moveClick = (code: string) => {
    let minusIndex = 0;
    setAllDoFlg(false);
    if (isZmCheck(user)) {
      minusIndex = 1;
    }
    if (isDmCheck(user)) {
      minusIndex = 2;
    }
    if (tabValue === TAB_ZO_VALUE) {
      setWorkZoCode(code);
      // 下層タブのクリア
      setWorkDoCode("");
      setOfcId("");
      setTenpoCode("");
      setIndexTabValue(TAB_DO_VALUE - minusIndex);
      setTabValue(TAB_DO_VALUE);
    }
    if (tabValue === TAB_DO_VALUE) {
      setWorkDoCode("00" + code);
      setOfcId("");
      setTenpoCode("");
      setIndexTabValue(TAB_OFC_VALUE - minusIndex);
      setTabValue(TAB_OFC_VALUE);
    }
    if (tabValue === TAB_OFC_VALUE) {
      setOfcId(code);
      setTenpoCode("");
      setIndexTabValue(TAB_KOTEN_VALUE - minusIndex);
      setTabValue(TAB_KOTEN_VALUE);
    }
    if (tabValue === TAB_KOTEN_VALUE) {
      setTenpoCode(code);
      setIndexTabValue(4 - minusIndex);
      setTabValue(4);
    }
  };

  // ZO名、DO名、OFC名のクリック
  const moveClickDMAll = () => {
    let minusIndex = 0;
    setAllDoFlg(true);
    if (isZmCheck(user)) {
      minusIndex = 1;
    }
    if (isDmCheck(user)) {
      minusIndex = 2;
    }
    if (tabValue === TAB_OFC_VALUE) {
      // setTenpoCode(code);
      setIndexTabValue(3 - minusIndex);
      setTabValue(3);
    }
  };

  // 選択ボタンのクリック
  const selectClick = (code: string, name: string) => {
    let addFlg = true;
    let userList = [];
    let cnt = 0;
    for (let i = 0; i < graphUserList.length; i++) {
      cnt += 1;
      if (code === graphUserList[i].code) {
        addFlg = false;
        continue;
      }
      userList.push(graphUserList[i]);
    }
    let colorNumber = cnt % 10;
    if (addFlg) {
      userList.push({ code, name, fill: fillCodeList[colorNumber] });
    }
    setGraphUserList(userList);
  };

  //　表示区分のセレクトボックス変更時の処理
  const doSelChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    let val: string = String(event.target.value);
    setSelectedTable(val);
    setSelectedSmallTitle(SMALL_ITEM_ALL_VALUE);
    setSelectedSmallFlg(false);
    let smallTitleList = [];
    let maxScoreDisplay = "";
    if (val === ITEM_ALL_VALUE) {
      setTargetAverageData(targetAverageData0);
      setTargetData(targetData0);
      setSmallTitleList([initSmallTitle]);
      smallTitleList = [initSmallTitle];
      changeGraphData(targetData0, tableHeaderList, targetAverageData0);
    }

    for (let tableItem of tableList) {
      if (val === String(tableItem.id)) {
        if (tableItem.max_score || String(tableItem.max_score) === "0") {
          maxScoreDisplay = String(tableItem.max_score);
        } else {
          maxScoreDisplay = "";
        }
      }
    }
    setMaxScoreDisplay(maxScoreDisplay);

    if (val === ITEM_1_VALUE) {
      setTargetAverageData(targetAverageData1);
      setTargetData(targetData1);
      setSmallTitleList(smallTitleList1);
      smallTitleList = smallTitleList1;
      changeGraphData(targetData1, tableHeaderList, targetAverageData1);
    }
    if (val === ITEM_2_VALUE) {
      setTargetAverageData(targetAverageData2);
      setTargetData(targetData2);
      setSmallTitleList(smallTitleList2);
      smallTitleList = smallTitleList2;
      changeGraphData(targetData2, tableHeaderList, targetAverageData2);
    }
    if (val === ITEM_3_VALUE) {
      setTargetAverageData(targetAverageData3);
      setTargetData(targetData3);
      setSmallTitleList(smallTitleList3);
      smallTitleList = smallTitleList3;
      changeGraphData(targetData3, tableHeaderList, targetAverageData3);
    }
    if (val === ITEM_4_VALUE) {
      setTargetAverageData(targetAverageData4);
      setTargetData(targetData4);
      setSmallTitleList(smallTitleList4);
      smallTitleList = smallTitleList4;
      changeGraphData(targetData4, tableHeaderList, targetAverageData4);
    }
    if (val === ITEM_5_VALUE) {
      setTargetAverageData(targetAverageData5);
      setTargetData(targetData5);
      setSmallTitleList(smallTitleList5);
      smallTitleList = smallTitleList5;
      changeGraphData(targetData5, tableHeaderList, targetAverageData5);
    }
    if (val === ITEM_6_VALUE) {
      if (tabValue === 3) {
        setSmallTitleList(smallTitleKoekake);
        smallTitleList = smallTitleKoekake;
      } else {
        setSmallTitleList(initSmallTitleKoekake);
        smallTitleList = initSmallTitleKoekake;
      }
    }

    let tmpMap: any = cloneMap(tmpInitTableMap);
    tmpMap["selectedTable"] = val;
    tmpMap["selectedSmallFlg"] = false;
    tmpMap["selectedSmallTable"] = SMALL_ITEM_ALL_VALUE;
    tmpMap["smallTitleList"] = smallTitleList;
    tmpMap["maxScore"] = maxScoreDisplay;

    dispatch(
      updateKeieiShindanManagerOldMap({
        keieiShindanManagerMap: tmpMap,
      })
    );
    setTmpInitTableMap(cloneMap(tmpMap));
    setTabValue(tabValue);
  };

  //　小項目区分のセレクトボックス変更時の処理
  const doSmallSelChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    let val: string = String(event.target.value);
    setSelectedSmallTitle(val);
    let maxScoreDisplay = "";

    if (val === SMALL_ITEM_ALL_VALUE) {
      setSelectedSmallFlg(false);
      for (let tableItem of tableList) {
        if (selectedTable === String(tableItem.id)) {
          if (tableItem.max_score || String(tableItem.max_score) === "0") {
            maxScoreDisplay = String(tableItem.max_score);
          } else {
            maxScoreDisplay = "";
          }
        }
      }
      setMaxScoreDisplay(maxScoreDisplay);

      if (selectedTable === ITEM_ALL_VALUE) {
        setTargetAverageData(targetAverageData0);
        setTargetData(targetData0);
        changeGraphData(targetData0, tableHeaderList, targetAverageData0);
      }
      if (selectedTable === ITEM_1_VALUE) {
        setTargetAverageData(targetAverageData1);
        setTargetData(targetData1);
        changeGraphData(targetData1, tableHeaderList, targetAverageData1);
      }
      if (selectedTable === ITEM_2_VALUE) {
        setTargetAverageData(targetAverageData2);
        setTargetData(targetData2);
        changeGraphData(targetData2, tableHeaderList, targetAverageData2);
      }
      if (selectedTable === ITEM_3_VALUE) {
        setTargetAverageData(targetAverageData3);
        setTargetData(targetData3);
        changeGraphData(targetData3, tableHeaderList, targetAverageData3);
      }
      if (selectedTable === ITEM_4_VALUE) {
        setTargetAverageData(targetAverageData4);
        setTargetData(targetData4);
        changeGraphData(targetData4, tableHeaderList, targetAverageData4);
      }
      if (selectedTable === ITEM_5_VALUE) {
        setTargetAverageData(targetAverageData5);
        setTargetData(targetData5);
        changeGraphData(targetData5, tableHeaderList, targetAverageData5);
      }

      let tmpMap: any = cloneMap(tmpInitTableMap);
      tmpMap["selectedSmallTable"] = val;
      tmpMap["selectedSmallFlg"] = false;
      tmpMap["maxScore"] = maxScoreDisplay;
      dispatch(
        updateKeieiShindanManagerOldMap({
          keieiShindanManagerMap: tmpMap,
        })
      );
      setTmpInitTableMap(cloneMap(tmpMap));
    } else {
      setSmallBaseMonth("");
      setSelectedSmallBaseDate(null);
      setSelectedSmallFlg(true);
      for (let tableItem of smallTitleList) {
        if (tableItem.id && String(tableItem.id) === val) {
          maxScoreDisplay = String(tableItem.max_score);
        }
      }
      setMaxScoreDisplay(maxScoreDisplay);

      if (selectedTable === ITEM_6_VALUE) {
        setMaxScoreDisplay("");
        getSmallData(
          workBaseData || DateTime.local(),
          KOEKAKE_BIG_ITEM_ID,
          Number(val) - 2,
          maxScoreDisplay
        );
      } else {
        getSmallData(
          workBaseData || DateTime.local(),
          Number(selectedTable) - 1,
          Number(val) - 1,
          maxScoreDisplay
        );
      }
      changeGraphData([], tableHeaderList, "");
    }
  };

  // 基準月の取得
  function getFirstDayOfWeek(target_date: string, addDate: number) {
    // 日付取得
    let today = zonedTimeToUtc(target_date, "Asia/Tokyo");
    let this_year = today.getFullYear();
    let this_month = today.getMonth();
    let date = today.getDate();
    let day_num = today.getDay();
    // Sunday - Saturday : 0 - 6
    if (day_num === 0) {
      day_num = 7;
    }
    let this_monday = date - day_num + 1 + addDate;

    //月曜日の年月日
    let firstDayOfWeek = new Date(this_year, this_month, this_monday);
    let month = firstDayOfWeek.getMonth() + 1;
    let year = firstDayOfWeek.getFullYear();
    if (!month || !year) {
      return "";
    }
    //文字列を作成
    return year + "年" + month + "月";
  }

  // 基準日の選択
  const handleBaseDate = (date: DateTime | null) => {
    if (selectedSmallFlg) {
      if (date) {
        let baseMonth = getFirstDayOfWeek(date.toFormat("yyyyMMdd"), 0);
        setSmallBaseMonth(baseMonth);
        getSmallBaseDate(date);
      } else {
        updataSmallBaseDataInit();
        setSmallBaseMonth("");
      }
      setSelectedSmallBaseDate(date);
      return date;
    } else {
      if (date) {
        let baseMonth = getFirstDayOfWeek(date.toFormat("yyyyMMdd"), 0);
        setBaseMonth(baseMonth);
        updateBaseDate(date);
      } else {
        setSelectedTable(ITEM_ALL_VALUE);
        setSmallTitleList([initSmallTitle]);
        updataBaseDataInit();
        setBaseMonth("");
      }
      setSelectedBaseDate(date);
      setSelectedSmallBaseDate(null);
      return date;
    }
  };

  // 基準日を空白にした際の初期化処理
  function updataBaseDataInit() {
    const resetBase = (dataList: any[]) => {
      let data: any[] = [];
      for (let i = 0; i < dataList.length; i++) {
        dataList[i]["baseMonthScore"] = "";
        dataList[i]["1wDiffBase"] = "";
        dataList[i]["2wDiffBase"] = "";
        dataList[i]["3wDiffBase"] = "";
        dataList[i]["4wDiffBase"] = "";
        dataList[i]["5wDiffBase"] = "";
        dataList[i]["1wDiffBaseReal"] = "";
        dataList[i]["2wDiffBaseReal"] = "";
        dataList[i]["3wDiffBaseReal"] = "";
        dataList[i]["4wDiffBaseReal"] = "";
        dataList[i]["5wDiffBaseReal"] = "";
        data.push(dataList[i]);
      }
      return data;
    };

    const resetAverage = (dataMap: any) => {
      let averageMap = dataMap;
      averageMap["baseMonthScore"] = "";
      averageMap["1wDiffBase"] = "";
      averageMap["2wDiffBase"] = "";
      averageMap["3wDiffBase"] = "";
      averageMap["4wDiffBase"] = "";
      averageMap["5wDiffBase"] = "";
      averageMap["1wDiffBaseReal"] = "";
      averageMap["2wDiffBaseReal"] = "";
      averageMap["3wDiffBaseReal"] = "";
      averageMap["4wDiffBaseReal"] = "";
      averageMap["5wDiffBaseReal"] = "";
      return dataMap;
    };
    setTargetData0(resetBase(targetData0));
    setTargetData1(resetBase(targetData1));
    setTargetData2(resetBase(targetData2));
    setTargetData3(resetBase(targetData3));
    setTargetData4(resetBase(targetData4));
    setTargetData5(resetBase(targetData5));
    setTargetData6(resetBase(targetData6));

    setTargetAverageData0(resetAverage(targetAverageData0));
    setTargetAverageData1(resetAverage(targetAverageData1));
    setTargetAverageData2(resetAverage(targetAverageData2));
    setTargetAverageData3(resetAverage(targetAverageData3));
    setTargetAverageData4(resetAverage(targetAverageData4));
    setTargetAverageData5(resetAverage(targetAverageData5));
    setTargetAverageData6(resetAverage(targetAverageData6));
  }

  // 小項目表示で基準日を空白にした際の初期化処理
  function updataSmallBaseDataInit() {
    const resetBase = (dataList: any[]) => {
      let data: any[] = [];
      for (let i = 0; i < dataList.length; i++) {
        dataList[i]["baseMonthScore"] = "";
        data.push(dataList[i]);
      }
      return data;
    };
    const resetAverage = (dataMap: any) => {
      let averageMap = dataMap;
      averageMap["baseMonthScore"] = "";
      averageMap["1wDiffBase"] = "";
      averageMap["2wDiffBase"] = "";
      averageMap["3wDiffBase"] = "";
      averageMap["4wDiffBase"] = "";
      averageMap["5wDiffBase"] = "";
      averageMap["1wDiffBaseReal"] = "";
      averageMap["2wDiffBaseReal"] = "";
      averageMap["3wDiffBaseReal"] = "";
      averageMap["4wDiffBaseReal"] = "";
      averageMap["5wDiffBaseReal"] = "";
      return dataMap;
    };
    setTargetSmallData(resetBase(targetSmallData));
    setTargetSmallAverageData(resetAverage(targetSmallAverageData));
  }

  // 小項目の情報取得
  function getSmallData(
    target_date: DateTime,
    bigItemId: any,
    smallId: any,
    workMaxScoreDisplay: any,
    templateItemName?: string
  ) {
    let workAnalysis = String(tabValue + 1);
    if (allDoFlg && workAnalysis === "4") {
      workAnalysis = "5";
    }
    let workBigItemId = String(bigItemId);
    let workSmallId = String(smallId);
    if (bigItemId === 5 && smallId >= 100) {
      workBigItemId = JUNSHU_BIG_ITEM_ID;
      workSmallId = String(smallId - 100);
    }
    const apiParams = {
      "api-name": "analysis",
      target_date: target_date.toFormat("yyyy/MM/dd HH:mm:ss"),
      zo_code: workZoCode,
      ofc_id: ofcId,
      do_code: workDoCode,
      analysis: workAnalysis,
      big_item_id: workBigItemId,
      small_item_id: workSmallId,
      is_oneMonth: false,
      template_item_name: templateItemName,
    };
    setExecuteFlg("2");
    // スコアのパーセント表示フラグ
    let percentFlg = false;
    let averageScoreFlg = false;
    let maxScore = 0;
    let defaultScore = 0;
    if (workAnalysis !== "4" && workAnalysis !== "5") {
      percentFlg = true;
    } else {
      if (workBigItemId === "5") {
        defaultScore = 2;
      } else if (workBigItemId === JUNSHU_BIG_ITEM_ID) {
        defaultScore = 5;
      } else if (workBigItemId === KOEKAKE_BIG_ITEM_ID) {
        averageScoreFlg = true;
      } else {
        getKeieiShindanMaxScore(workBigItemId, workSmallId).then((res) => {
          maxScore = res;
        });
      }
    }
    const url =
      process.env.REACT_APP_API_URL_J11SPB22 + "keieishindan/analysis-small";
    return postRequest(url, apiParams)
      .then((res) => {
        let dataList: any[] = res.data.dataList;
        if (dataList) {
          for (let i = 0; i < dataList.length; i++) {
            let datajsList: any = dataList[i];
            let averageScoreBreakdown: any[] =
              datajsList.average_score_breakdown;
            let monthValue: any = datajsList.month_value[0];
            let submissionMonthValue: any = datajsList.submission_month;

            // let maxScore = "";
            let monthList: any[] = [];
            let headerList = [];
            const dataMapCreate = (
              dataMap: any,
              headerList: any[],
              no: number,
              resultMap: any
            ) => {
              let map: any = {
                name: dataMap.name,
                code: dataMap.code,
                sortDoCode: dataMap.sortDoCode,
                sortOfcCode: dataMap.sortOfcCode,
                ofcName: dataMap.ofcName,
              };
              map["id5"] = resultMap.result1["id"];
              map["id4"] = resultMap.result2["id"];
              map["id3"] = resultMap.result3["id"];
              map["id2"] = resultMap.result4["id"];
              map["id1"] = resultMap.result5["id"];
              map[headerList[4]] = roundOffDecimal(
                resultMap.result1["score" + no]
              );
              map[headerList[3]] = roundOffDecimal(
                resultMap.result2["score" + no]
              );
              map[headerList[2]] = roundOffDecimal(
                resultMap.result3["score" + no]
              );
              map[headerList[1]] = roundOffDecimal(
                resultMap.result4["score" + no]
              );
              map[headerList[0]] = roundOffDecimal(
                resultMap.result5["score" + no]
              );

              map["5wDiff"] = calcDiff(
                resultMap.result1["score" + no],
                resultMap.result2["score" + no]
              );
              map["4wDiff"] = calcDiff(
                resultMap.result2["score" + no],
                resultMap.result3["score" + no]
              );
              map["3wDiff"] = calcDiff(
                resultMap.result3["score" + no],
                resultMap.result4["score" + no]
              );
              map["2wDiff"] = calcDiff(
                resultMap.result4["score" + no],
                resultMap.result5["score" + no]
              );
              map["1wDiff"] = calcDiff(
                resultMap.result5["score" + no],
                resultMap.result6["score" + no]
              );

              map[headerList[4] + "Real"] = roundOffDecimal(
                resultMap.result1["real_score" + no]
              );
              map[headerList[3] + "Real"] = roundOffDecimal(
                resultMap.result2["real_score" + no]
              );
              map[headerList[2] + "Real"] = roundOffDecimal(
                resultMap.result3["real_score" + no]
              );
              map[headerList[1] + "Real"] = roundOffDecimal(
                resultMap.result4["real_score" + no]
              );
              map[headerList[0] + "Real"] = roundOffDecimal(
                resultMap.result5["real_score" + no]
              );

              map["5wDiffReal"] = calcDiff(
                resultMap.result1["real_score" + no],
                resultMap.result2["real_score" + no]
              );
              map["4wDiffReal"] = calcDiff(
                resultMap.result2["real_score" + no],
                resultMap.result3["real_score" + no]
              );
              map["3wDiffReal"] = calcDiff(
                resultMap.result3["real_score" + no],
                resultMap.result4["real_score" + no]
              );
              map["2wDiffReal"] = calcDiff(
                resultMap.result4["real_score" + no],
                resultMap.result5["real_score" + no]
              );
              map["1wDiffReal"] = calcDiff(
                resultMap.result5["real_score" + no],
                resultMap.result6["real_score" + no]
              );

              return map;
            };

            // 合計値用インターフェイス
            interface totalMap {
              "1w": number;
              "2w": number;
              "3w": number;
              "4w": number;
              "5w": number;
              "6w": number;
              "1wReal": number;
              "2wReal": number;
              "3wReal": number;
              "4wReal": number;
              "5wReal": number;
              "6wReal": number;
            }
            const initTotalMap = () => {
              let map: totalMap = {
                "1w": 0,
                "2w": 0,
                "3w": 0,
                "4w": 0,
                "5w": 0,
                "6w": 0,
                "1wReal": 0,
                "2wReal": 0,
                "3wReal": 0,
                "4wReal": 0,
                "5wReal": 0,
                "6wReal": 0,
              };
              return map;
            };
            // 合計値加算
            const addTotals = (
              map: totalMap,
              num1: any,
              num2: any,
              num3: any,
              num4: any,
              num5: any,
              realNum1: any,
              realNum2: any,
              realNum3: any,
              realNum4: any,
              realNum5: any,
              num6?: any
            ) => {
              map["1w"] += roundOffDecimal(num1);
              map["2w"] += roundOffDecimal(num2);
              map["3w"] += roundOffDecimal(num3);
              map["4w"] += roundOffDecimal(num4);
              map["5w"] += roundOffDecimal(num5);
              if (realNum1) {
                map["1wReal"] += roundOffDecimal(realNum1);
                map["2wReal"] += roundOffDecimal(realNum2);
                map["3wReal"] += roundOffDecimal(realNum3);
                map["4wReal"] += roundOffDecimal(realNum4);
                map["5wReal"] += roundOffDecimal(realNum5);
              } else {
                map["1wReal"] += roundOffDecimal(num1);
                map["2wReal"] += roundOffDecimal(num2);
                map["3wReal"] += roundOffDecimal(num3);
                map["4wReal"] += roundOffDecimal(num4);
                map["5wReal"] += roundOffDecimal(num5);
              }
              // 0week
              map["6w"] += roundOffDecimal(num6);
            };

            // main処理
            let totalCalMap1: any = {
              score: 0,
              count: 0,
              maxScore: 0,
              real_score: 0,
            };
            let totalCalMap2: any = {
              score: 0,
              count: 0,
              maxScore: 0,
              real_score: 0,
            };
            let totalCalMap3: any = {
              score: 0,
              count: 0,
              maxScore: 0,
              real_score: 0,
            };
            let totalCalMap4: any = {
              score: 0,
              count: 0,
              maxScore: 0,
              real_score: 0,
            };
            let totalCalMap5: any = {
              score: 0,
              count: 0,
              maxScore: 0,
              real_score: 0,
            };
            let totalCalMap6: any = {
              score: 0,
              count: 0,
              maxScore: 0,
              real_score: 0,
            };
            const countTotalMap = (
              score: any,
              totalmap: any,
              maxScore: any,
              defaultScore?: any
            ) => {
              if (score !== "") {
                totalmap.count += 1;
                if (defaultScore) {
                  totalmap.score += defaultScore + score;
                  totalmap.real_score += score;
                } else {
                  totalmap.score += score;
                  totalmap.real_score += score;
                }
                totalmap.maxScore += maxScore;
              }
            };
            // 週名称の設定
            if (monthValue) {
              headerList.push(monthValue.month5);
              headerList.push(monthValue.month4);
              headerList.push(monthValue.month3);
              headerList.push(monthValue.month2);
              headerList.push(monthValue.month1);
              setTableHeaderList(headerList);
            }
            // 提出数用週
            if (submissionMonthValue && submissionMonthValue.length > 0) {
              let list: string[] = [];
              list.push(submissionMonthValue[0].month5);
              list.push(submissionMonthValue[0].month4);
              list.push(submissionMonthValue[0].month3);
              list.push(submissionMonthValue[0].month2);
              list.push(submissionMonthValue[0].month1);
              setTableSubmissionHeaderList(list);
            }
            monthList = sortCode(monthList);
            // 項目別の設定
            let scoreList: any[] = [];
            let totalAveragePercentMap: totalMap = initTotalMap();

            let month1Count = 0;
            let month2Count = 0;
            let month3Count = 0;
            let month4Count = 0;
            let month5Count = 0;
            let month6Count = 0;

            for (let j = 0; j < averageScoreBreakdown.length; j++) {
              let name = averageScoreBreakdown[j].name;
              let code = averageScoreBreakdown[j].code;
              let sortDoCode = averageScoreBreakdown[j].sort_docode;
              let sortOfcCode = averageScoreBreakdown[j].sort_ofc_code;
              let ofcName = averageScoreBreakdown[j].ofc_name;
              let result1 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result1
                  ? averageScoreBreakdown[j].result1
                  : "";
              let result2 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result2
                  ? averageScoreBreakdown[j].result2
                  : "";
              let result3 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result3
                  ? averageScoreBreakdown[j].result3
                  : "";
              let result4 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result4
                  ? averageScoreBreakdown[j].result4
                  : "";
              let result5 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result5
                  ? averageScoreBreakdown[j].result5
                  : "";
              let result6 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result6
                  ? averageScoreBreakdown[j].result6
                  : "";
              let submissionMonthValue: any =
                averageScoreBreakdown[j].submissionMonth;
              let map: any = { name, code, sortDoCode, sortOfcCode, ofcName };

              month1Count += countTotalTarget(result1["recordCount1"]);
              month2Count += countTotalTarget(result2["recordCount1"]);
              month3Count += countTotalTarget(result3["recordCount1"]);
              month4Count += countTotalTarget(result4["recordCount1"]);
              month5Count += countTotalTarget(result5["recordCount1"]);
              month6Count += countTotalTarget(result6["recordCount1"]);

              if (defaultScore > 0) {
                countTotalMap(
                  result1["score1"],
                  totalCalMap1,
                  defaultScore,
                  defaultScore
                );
                countTotalMap(
                  result2["score1"],
                  totalCalMap2,
                  defaultScore,
                  defaultScore
                );
                countTotalMap(
                  result3["score1"],
                  totalCalMap3,
                  defaultScore,
                  defaultScore
                );
                countTotalMap(
                  result4["score1"],
                  totalCalMap4,
                  defaultScore,
                  defaultScore
                );
                countTotalMap(
                  result5["score1"],
                  totalCalMap5,
                  defaultScore,
                  defaultScore
                );
                countTotalMap(
                  result6["score1"],
                  totalCalMap6,
                  defaultScore,
                  defaultScore
                );
              } else {
                countTotalMap(result1["score1"], totalCalMap1, maxScore);
                countTotalMap(result2["score1"], totalCalMap2, maxScore);
                countTotalMap(result3["score1"], totalCalMap3, maxScore);
                countTotalMap(result4["score1"], totalCalMap4, maxScore);
                countTotalMap(result5["score1"], totalCalMap5, maxScore);
                countTotalMap(result6["score1"], totalCalMap6, maxScore);
              }

              addTotals(
                totalAveragePercentMap,
                result1["score1"],
                result2["score1"],
                result3["score1"],
                result4["score1"],
                result5["score1"],
                result1["real_score1"],
                result2["real_score1"],
                result3["real_score1"],
                result4["real_score1"],
                result5["real_score1"],
                result6["score1"]
              );

              let resultMap = {
                result1,
                result2,
                result3,
                result4,
                result5,
                result6,
              };
              scoreList.push(
                tabValue === TAB_OFC_VALUE
                  ? Object.assign(
                      dataMapCreate(map, headerList, 1, resultMap),
                      submissionMonthValue
                    )
                  : tabValue === TAB_KOTEN_VALUE
                  ? Object.assign(
                      dataMapCreate(map, headerList, 1, resultMap)
                      // createAttachedIconMap(resultMap)
                    )
                  : dataMapCreate(map, headerList, 1, resultMap)
              );
            }

            // 統合の設定
            let averageTitle = "";
            if (tabValue === TAB_ZO_VALUE) {
              averageTitle = "ZO";
            } else if (tabValue === TAB_DO_VALUE) {
              averageTitle = "DO";
            } else if (tabValue === TAB_OFC_VALUE) {
              averageTitle = "OFC";
            } else if (tabValue === TAB_KOTEN_VALUE) {
              averageTitle = "個別";
            }
            // 地区平均の作成
            let averageMap: any = {
              name: "地区平均／" + averageTitle + "平均",
              code: "average",
            };
            // totalには5～1が逆に入っている
            let average1 = calcPercent(
              totalCalMap1.score,
              totalCalMap1.maxScore
            );
            let average2 = calcPercent(
              totalCalMap2.score,
              totalCalMap2.maxScore
            );
            let average3 = calcPercent(
              totalCalMap3.score,
              totalCalMap3.maxScore
            );
            let average4 = calcPercent(
              totalCalMap4.score,
              totalCalMap4.maxScore
            );
            let average5 = calcPercent(
              totalCalMap5.score,
              totalCalMap5.maxScore
            );
            let average6 = calcPercent(
              totalCalMap6.score,
              totalCalMap6.maxScore
            );

            let average1Real = roundOffDecimal(
              Number(totalCalMap1.real_score) / totalCalMap1.count
            );
            let average2Real = roundOffDecimal(
              Number(totalCalMap2.real_score) / totalCalMap2.count
            );
            let average3Real = roundOffDecimal(
              Number(totalCalMap3.real_score) / totalCalMap3.count
            );
            let average4Real = roundOffDecimal(
              Number(totalCalMap4.real_score) / totalCalMap4.count
            );
            let average5Real = roundOffDecimal(
              Number(totalCalMap5.real_score) / totalCalMap5.count
            );
            let average6Real = roundOffDecimal(
              Number(totalCalMap6.real_score) / totalCalMap6.count
            );

            if (averageScoreFlg) {
              average1 = roundOffDecimal(
                Number(totalAveragePercentMap["1w"]) / totalCalMap1.count
              );
              average2 = roundOffDecimal(
                Number(totalAveragePercentMap["2w"]) / totalCalMap2.count
              );
              average3 = roundOffDecimal(
                Number(totalAveragePercentMap["3w"]) / totalCalMap3.count
              );
              average4 = roundOffDecimal(
                Number(totalAveragePercentMap["4w"]) / totalCalMap4.count
              );
              average5 = roundOffDecimal(
                Number(totalAveragePercentMap["5w"]) / totalCalMap5.count
              );

              average1Real = roundOffDecimal(
                Number(totalAveragePercentMap["1wReal"]) / totalCalMap1.count
              );
              average2Real = roundOffDecimal(
                Number(totalAveragePercentMap["2wReal"]) / totalCalMap2.count
              );
              average3Real = roundOffDecimal(
                Number(totalAveragePercentMap["3wReal"]) / totalCalMap3.count
              );
              average4Real = roundOffDecimal(
                Number(totalAveragePercentMap["4wReal"]) / totalCalMap4.count
              );
              average5Real = roundOffDecimal(
                Number(totalAveragePercentMap["5wReal"]) / totalCalMap5.count
              );
              average6Real = roundOffDecimal(
                Number(totalAveragePercentMap["6wReal"]) / totalCalMap6.count
              );
            }
            if (percentFlg) {
              average1 = roundOffDecimal(
                Number(totalAveragePercentMap["1w"]) / month1Count
              );
              average2 = roundOffDecimal(
                Number(totalAveragePercentMap["2w"]) / month2Count
              );
              average3 = roundOffDecimal(
                Number(totalAveragePercentMap["3w"]) / month3Count
              );
              average4 = roundOffDecimal(
                Number(totalAveragePercentMap["4w"]) / month4Count
              );
              average5 = roundOffDecimal(
                Number(totalAveragePercentMap["5w"]) / month5Count
              );
              average6 = roundOffDecimal(
                Number(totalAveragePercentMap["6w"]) / month6Count
              );

              average1Real = roundOffDecimal(
                Number(totalAveragePercentMap["1wReal"]) / month1Count
              );
              average2Real = roundOffDecimal(
                Number(totalAveragePercentMap["2wReal"]) / month2Count
              );
              average3Real = roundOffDecimal(
                Number(totalAveragePercentMap["3wReal"]) / month3Count
              );
              average4Real = roundOffDecimal(
                Number(totalAveragePercentMap["4wReal"]) / month4Count
              );
              average5Real = roundOffDecimal(
                Number(totalAveragePercentMap["5wReal"]) / month5Count
              );
              average6Real = roundOffDecimal(
                Number(totalAveragePercentMap["6wReal"]) / month6Count
              );

              averageMap["1wDiff"] = calcDiff(average5, average6);
              averageMap["2wDiff"] = calcDiff(average4, average5);
              averageMap["3wDiff"] = calcDiff(average3, average4);
              averageMap["4wDiff"] = calcDiff(average2, average3);
              averageMap["5wDiff"] = calcDiff(average1, average2);

              averageMap["1wDiffReal"] = calcDiff(average5Real, average6Real);
              averageMap["2wDiffReal"] = calcDiff(average4Real, average5Real);
              averageMap["3wDiffReal"] = calcDiff(average3Real, average4Real);
              averageMap["4wDiffReal"] = calcDiff(average2Real, average3Real);
              averageMap["5wDiffReal"] = calcDiff(average1Real, average2Real);
            }

            averageMap[headerList[0]] = average5;
            averageMap[headerList[1]] = average4;
            averageMap[headerList[2]] = average3;
            averageMap[headerList[3]] = average2;
            averageMap[headerList[4]] = average1;

            averageMap[headerList[0] + "Real"] = average5Real;
            averageMap[headerList[1] + "Real"] = average4Real;
            averageMap[headerList[2] + "Real"] = average3Real;
            averageMap[headerList[3] + "Real"] = average2Real;
            averageMap[headerList[4] + "Real"] = average1Real;

            let tmpMap: any = cloneMap(tmpInitTableMap);
            tmpMap["selectedSmallFlg"] = true;
            tmpMap["targetSmallData"] = cloneListMap(sortCode(scoreList));
            tmpMap["targetSmallAverageData"] = cloneMap(averageMap);
            tmpMap["selectedSmallTable"] = smallId + 1;
            tmpMap["maxScore"] = workMaxScoreDisplay;

            dispatch(
              updateKeieiShindanManagerOldMap({
                keieiShindanManagerMap: tmpMap,
              })
            );
            setTmpInitTableMap(cloneMap(tmpMap));

            setTargetSmallAverageData(averageMap);
            setTargetSmallData(sortCode(scoreList));
            return {
              monthList,
              headerList,
            };
          }
        }
      })
      .finally(() => {
        setExecuteFlg("");
      });
  }

  // 小項目での基準日情報取得
  function getSmallBaseDate(baseDate: DateTime) {
    let workAnalysis = String(tabValue + 1);
    let averageScoreFlg = false;
    if (allDoFlg && workAnalysis === "4") {
      workAnalysis = "5";
    }
    let bigItemId: String = String(Number(selectedTable) - 1);
    let smallItemId: String = String(Number(selectedSmallTitle) - 1);

    let workBigItemId = String(bigItemId);
    let workSmallId = String(smallItemId);
    // 労使関連と遵守項目の判定
    if (
      Number(bigItemId) === Number(ITEM_5_VALUE) - 1 &&
      Number(smallItemId) >= 100
    ) {
      workBigItemId = JUNSHU_BIG_ITEM_ID;
      workSmallId = String(Number(smallItemId) - 100);
    }
    // 声かけ人数
    if (bigItemId === String(Number(ITEM_6_VALUE) - 1)) {
      averageScoreFlg = true;
      workBigItemId = KOEKAKE_BIG_ITEM_ID;
      workSmallId = String(Number(smallItemId) - 1);
    }
    const apiParams = {
      "api-name": "analysis",
      target_date: baseDate.toFormat("yyyy/MM/dd HH:mm:ss"),
      ofc_id: ofcId,
      zo_code: workZoCode,
      do_code: workDoCode,
      analysis: workAnalysis,
      big_item_id: workBigItemId,
      small_item_id: workSmallId,
      template_item_name: "",
      is_oneMonth: true,
    };
    setExecuteFlg("2");
    // スコアのパーセント表示フラグ
    let percentFlg = false;
    let maxScore = 0;
    let defaultScore = 0;
    if (workAnalysis !== "4" && workAnalysis !== "5") {
      percentFlg = true;
    } else {
      if (workBigItemId === "5") {
        defaultScore = 2;
      } else if (workBigItemId === JUNSHU_BIG_ITEM_ID) {
        defaultScore = 5;
      } else {
        getKeieiShindanMaxScore(workBigItemId, workSmallId).then((res) => {
          maxScore = res;
        });
      }
    }
    const url =
      process.env.REACT_APP_API_URL_J11SPB22 + "keieishindan/analysis-small";
    return postRequest(url, apiParams)
      .then((res) => {
        const breakDownDataMap = (
          data: any[],
          code: any,
          score: number,
          id: any,
          realScore: number
        ) => {
          let dataMap: any = {};
          for (let i = 0; i < data.length; i++) {
            if (code === data[i].code) {
              dataMap = data[i];
            }
          }
          dataMap["baseMonthScore"] = roundOffDecimal(score);
          dataMap["baseMonthScoreReal"] = roundOffDecimal(realScore);
          dataMap["baseId"] = id;
          if (percentFlg) {
            return updateDiff(score, dataMap, tableHeaderList, realScore);
          }
          return dataMap;
        };

        const updateDiff = (
          baseScore: number,
          targetMap: any,
          tableHeaderList: any[],
          baseRealScore: number
        ) => {
          let dataMap: any = targetMap;

          dataMap["1wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[0]],
            baseScore
          );
          dataMap["2wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[1]],
            baseScore
          );
          dataMap["3wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[2]],
            baseScore
          );
          dataMap["4wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[3]],
            baseScore
          );
          dataMap["5wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[4]],
            baseScore
          );

          dataMap["1wDiffBaseReal"] = calcDiff(
            dataMap[tableHeaderList[0] + "Real"],
            baseRealScore
          );
          dataMap["2wDiffBaseReal"] = calcDiff(
            dataMap[tableHeaderList[1] + "Real"],
            baseRealScore
          );
          dataMap["3wDiffBaseReal"] = calcDiff(
            dataMap[tableHeaderList[2] + "Real"],
            baseRealScore
          );
          dataMap["4wDiffBaseReal"] = calcDiff(
            dataMap[tableHeaderList[3] + "Real"],
            baseRealScore
          );
          dataMap["5wDiffBaseReal"] = calcDiff(
            dataMap[tableHeaderList[4] + "Real"],
            baseRealScore
          );

          return dataMap;
        };

        // main処理
        let totalScore0 = 0;
        let totalRealScore0 = 0;
        let totalMaxScore = 0;
        let dataList: any[] = res.data.dataList;
        if (dataList) {
          for (let i = 0; i < dataList.length; i++) {
            let datajsList: any = dataList[i];

            let averageScoreBreakdown: any[] =
              datajsList.average_score_breakdown;
            let monthList: any[] = [];
            monthList = sortCode(monthList);

            let breakDownList: any[] = [];
            let breakDownData = targetSmallData;
            let breakDownAverageData = targetSmallAverageData;
            let totalBaseScore = 0;
            let totalBaseScoreReal = 0;
            let month1Count = 0;
            for (let j = 0; j < averageScoreBreakdown.length; j++) {
              let code = averageScoreBreakdown[j].code;
              let result1 =
                averageScoreBreakdown[j] && averageScoreBreakdown[j].result1
                  ? averageScoreBreakdown[j].result1
                  : "";
              let id = result1.id;
              if (result1["score1"] !== "") {
                if (defaultScore > 0) {
                  totalScore0 += Number(result1["score1"]) + defaultScore;
                  totalRealScore0 += Number(result1["score1"]);
                  totalMaxScore += defaultScore;
                } else {
                  totalScore0 += Number(result1["score1"]);
                  totalRealScore0 += Number(result1["score1"]);
                  totalMaxScore += maxScore;
                }
              }
              totalBaseScore += Number(result1.score1);
              totalBaseScoreReal += Number(result1.real_score1);
              if (result1.score1 !== "") {
                month1Count += countTotalTarget(result1.recordCount1);
              }
              const attachedIconMap: {
                photo_flag_base: string;
                comment_flag_base: string;
              } = {
                photo_flag_base: result1.photo_flag,
                comment_flag_base: result1.comment_flag,
              };
              breakDownList.push(
                Object.assign(
                  breakDownDataMap(
                    breakDownData,
                    code,
                    result1.score1,
                    id,
                    result1.real_score1
                  ),
                  attachedIconMap
                )
              );
            }
            // totalには5～1が逆に入っている
            let average0 = calcPercent(totalScore0, totalMaxScore);
            let average0Real = roundOffDecimal(
              Number(totalRealScore0) / month1Count
            );

            if (averageScoreFlg) {
              average0 = roundOffDecimal(Number(totalScore0) / month1Count);
              average0Real = roundOffDecimal(Number(totalScore0) / month1Count);
              updateDiff(
                average0,
                breakDownAverageData,
                tableHeaderList,
                average0Real
              );
            }
            if (percentFlg) {
              average0 = roundOffDecimal(Number(totalBaseScore) / month1Count);
              average0Real = roundOffDecimal(
                Number(totalBaseScoreReal) / month1Count
              );
              updateDiff(
                average0,
                breakDownAverageData,
                tableHeaderList,
                average0Real
              );
            }
            breakDownAverageData["baseMonthScore"] = average0;
            breakDownAverageData["baseMonthScoreReal"] = average0Real;

            setTargetSmallAverageData(breakDownAverageData);
            setTargetSmallData(sortCode(breakDownList));

            let tmpMap: any = cloneMap(tmpInitTableMap);
            tmpMap["selectedSmallBaseDate"] = baseDate.toFormat("yyyyMMdd");
            tmpMap["targetSmallAverageData"] = cloneMap(breakDownAverageData);
            tmpMap["targetSmallData"] = cloneListMap(sortCode(breakDownList));
            dispatch(
              updateKeieiShindanManagerOldMap({
                keieiShindanManagerMap: tmpMap,
              })
            );
            setTmpInitTableMap(cloneMap(tmpMap));
          }
        }
      })
      .catch((r) => {
        setDialogMessage([String(r)]);
        setDialogFlg(true);
      })
      .finally(() => {
        setExecuteFlg("");
      });
  }

  // 基準週による比較値更新
  function updateBaseDate(baseDate: DateTime) {
    userLogging("KeieiShindan", "管理者分析#基準日選択", baseDate.toString());
    let workAnalysis = String(tabValue + 1);
    if (allDoFlg && workAnalysis === "4") {
      workAnalysis = "5";
    }
    const apiParams = {
      "api-name": "analysis",
      target_date: baseDate.toFormat("yyyy/MM/dd HH:mm:ss"),
      zo_code: workZoCode,
      do_code: workDoCode,
      ofc_id: ofcId,
      tenpo_code: tenpoCode,
      analysis: workAnalysis, //String(tabValue + 1),
      is_oneMonth: true,
    };
    setExecuteFlg("2");
    const url = process.env.REACT_APP_API_URL_J11SPB22 + "keieishindan/analysis";
    return postRequest(url, apiParams)
      .then((res) => {
        setSelectedTable(ITEM_ALL_VALUE);
        setSmallTitleList([initSmallTitle]);
        const breakDownDataMap = (
          data: any[],
          code: any,
          score: number,
          realScore: number
        ) => {
          let dataMap: any = {};
          for (let i = 0; i < data.length; i++) {
            if (code === data[i].code) {
              dataMap = data[i];
            }
          }
          dataMap["baseMonthScore"] = roundOffDecimal(score);
          dataMap["baseMonthScoreReal"] = roundOffDecimal(realScore);
          return updateDiff(score, dataMap, tableHeaderList, realScore);
        };

        const updateDiff = (
          baseScore: number,
          targetMap: any,
          tableHeaderList: any[],
          baseRealScore: number
        ) => {
          let dataMap: any = targetMap;

          dataMap["1wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[0]],
            baseScore
          );
          dataMap["2wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[1]],
            baseScore
          );
          dataMap["3wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[2]],
            baseScore
          );
          dataMap["4wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[3]],
            baseScore
          );
          dataMap["5wDiffBase"] = calcDiff(
            dataMap[tableHeaderList[4]],
            baseScore
          );
          dataMap["1wDiffBaseReal"] = calcDiff(
            dataMap[tableHeaderList[0] + "Real"],
            baseRealScore
          );
          dataMap["2wDiffBaseReal"] = calcDiff(
            dataMap[tableHeaderList[1] + "Real"],
            baseRealScore
          );
          dataMap["3wDiffBaseReal"] = calcDiff(
            dataMap[tableHeaderList[2] + "Real"],
            baseRealScore
          );
          dataMap["4wDiffBaseReal"] = calcDiff(
            dataMap[tableHeaderList[3] + "Real"],
            baseRealScore
          );
          dataMap["5wDiffBaseReal"] = calcDiff(
            dataMap[tableHeaderList[4] + "Real"],
            baseRealScore
          );
          return dataMap;
        };

        const getUpdateAverage = (
          data: any,
          totalScore: number | string,
          count: number,
          totalRealScore: number | string
        ) => {
          let averageMap = data;
          averageMap["baseMonthScore"] = calcAverage(totalScore, count);
          averageMap["baseMonthScoreReal"] = calcAverage(totalRealScore, count);
          updateDiff(
            calcAverage(totalScore, count),
            averageMap,
            tableHeaderList,
            calcAverage(totalRealScore, count)
          );
          return averageMap;
        };

        // main処理
        let dataList: any[] = res.data.dataList;
        if (dataList) {
          for (let i = 0; i < dataList.length; i++) {
            let datajsList: any = dataList[i];
            let breakdownScoreList: any[] = datajsList.average_score_breakdown;

            let month1Count = 0;
            let breakDownList_0: any[] = [];
            let breakDownList_1: any[] = [];
            let breakDownList_2: any[] = [];
            let breakDownList_3: any[] = [];
            let breakDownList_4: any[] = [];
            let breakDownList_5: any[] = [];
            let breakDownList_6: any[] = [];
            let breakDownData_0 = targetData0;
            let breakDownData_1 = targetData1;
            let breakDownData_2 = targetData2;
            let breakDownData_3 = targetData3;
            let breakDownData_4 = targetData4;
            let breakDownData_5 = targetData5;
            let breakDownData_6 = targetData6;
            let totalScore0 = 0;
            let totalScore1 = 0;
            let totalScore2 = 0;
            let totalScore3 = 0;
            let totalScore4 = 0;
            let totalScore5 = 0;
            let totalScore6 = 0;
            let totalRealScore1 = 0;
            let totalRealScore2 = 0;
            let totalRealScore3 = 0;
            let totalRealScore4 = 0;
            let totalRealScore5 = 0;
            let totalRealScore6 = 0;

            for (let j = 0; j < breakdownScoreList.length; j++) {
              let code = breakdownScoreList[j].codeName.code;
              let result1 =
                breakdownScoreList[j] && breakdownScoreList[j].result1
                  ? breakdownScoreList[j].result1
                  : "";

              month1Count += countTotalTarget(result1.recordCount1);
              totalScore0 += Number(result1.score0);
              totalScore1 += Number(result1.score1);
              totalScore2 += Number(result1.score2);
              totalScore3 += Number(result1.score3);
              totalScore4 += Number(result1.score4);
              totalScore5 += Number(result1.score5);
              totalScore6 += Number(result1.score6);
              // totalRealScore0 += Number(result1.score0);
              totalRealScore1 += Number(result1.real_score1);
              totalRealScore2 += Number(result1.real_score2);
              totalRealScore3 += Number(result1.real_score3);
              totalRealScore4 += Number(result1.real_score4);
              totalRealScore5 += Number(result1.real_score5);
              totalRealScore6 += Number(result1.real_score6);
              breakDownList_0.push(
                breakDownDataMap(
                  breakDownData_0,
                  code,
                  result1.score0,
                  result1.real_score0
                )
              );
              breakDownList_1.push(
                breakDownDataMap(
                  breakDownData_1,
                  code,
                  result1.score1,
                  result1.real_score1
                )
              );
              breakDownList_2.push(
                breakDownDataMap(
                  breakDownData_2,
                  code,
                  result1.score2,
                  result1.real_score2
                )
              );
              breakDownList_3.push(
                breakDownDataMap(
                  breakDownData_3,
                  code,
                  result1.score3,
                  result1.real_score3
                )
              );
              breakDownList_4.push(
                breakDownDataMap(
                  breakDownData_4,
                  code,
                  result1.score4,
                  result1.real_score4
                )
              );
              breakDownList_5.push(
                breakDownDataMap(
                  breakDownData_5,
                  code,
                  result1.score5,
                  result1.real_score5
                )
              );
              breakDownList_6.push(
                breakDownDataMap(
                  breakDownData_6,
                  code,
                  result1.score6,
                  result1.real_score6
                )
              );
            }

            let averageMap = getUpdateAverage(
              targetAverageData0,
              totalScore0,
              month1Count,
              0
            );
            setTargetAverageData(averageMap);
            setTargetAverageData0(averageMap);
            setTargetAverageData1(
              getUpdateAverage(
                targetAverageData1,
                totalScore1,
                month1Count,
                totalRealScore1
              )
            );
            setTargetAverageData2(
              getUpdateAverage(
                targetAverageData2,
                totalScore2,
                month1Count,
                totalRealScore2
              )
            );
            setTargetAverageData3(
              getUpdateAverage(
                targetAverageData3,
                totalScore3,
                month1Count,
                totalRealScore3
              )
            );
            setTargetAverageData4(
              getUpdateAverage(
                targetAverageData4,
                totalScore4,
                month1Count,
                totalRealScore4
              )
            );
            setTargetAverageData5(
              getUpdateAverage(
                targetAverageData5,
                totalScore5,
                month1Count,
                totalRealScore5
              )
            );
            setTargetAverageData6(
              getUpdateAverage(
                targetAverageData6,
                totalScore6,
                month1Count,
                totalRealScore6
              )
            );

            setTargetData(sortCode(breakDownList_0));
            setTargetData0(sortCode(breakDownList_0));
            setTargetData1(sortCode(breakDownList_1));
            setTargetData2(sortCode(breakDownList_2));
            setTargetData3(sortCode(breakDownList_3));
            setTargetData4(sortCode(breakDownList_4));
            setTargetData5(sortCode(breakDownList_5));
            setTargetData6(sortCode(breakDownList_6));
            let tmpMap: any = cloneMap(tmpInitTableMap);
            tmpMap["targetAverageData0"] = cloneMap(
              getUpdateAverage(targetAverageData0, totalScore0, month1Count, 0)
            );
            tmpMap["targetAverageData1"] = cloneMap(
              getUpdateAverage(
                targetAverageData1,
                totalScore1,
                month1Count,
                totalRealScore1
              )
            );
            tmpMap["targetAverageData2"] = cloneMap(
              getUpdateAverage(
                targetAverageData2,
                totalScore2,
                month1Count,
                totalRealScore2
              )
            );
            tmpMap["targetAverageData3"] = cloneMap(
              getUpdateAverage(
                targetAverageData3,
                totalScore3,
                month1Count,
                totalRealScore3
              )
            );
            tmpMap["targetAverageData4"] = cloneMap(
              getUpdateAverage(
                targetAverageData4,
                totalScore4,
                month1Count,
                totalRealScore4
              )
            );
            tmpMap["targetAverageData5"] = cloneMap(
              getUpdateAverage(
                targetAverageData5,
                totalScore5,
                month1Count,
                totalRealScore5
              )
            );
            tmpMap["targetAverageData6"] = cloneMap(
              getUpdateAverage(
                targetAverageData6,
                totalScore6,
                month1Count,
                totalRealScore6
              )
            );
            tmpMap["targetList0"] = cloneListMap(sortCode(breakDownList_0));
            tmpMap["targetList1"] = cloneListMap(sortCode(breakDownList_1));
            tmpMap["targetList2"] = cloneListMap(sortCode(breakDownList_2));
            tmpMap["targetList3"] = cloneListMap(sortCode(breakDownList_3));
            tmpMap["targetList4"] = cloneListMap(sortCode(breakDownList_4));
            tmpMap["targetList5"] = cloneListMap(sortCode(breakDownList_5));
            tmpMap["targetList6"] = cloneListMap(sortCode(breakDownList_6));
            tmpMap["selectedBaseDate"] = baseDate.toFormat("yyyyMMdd");
            tmpMap["selectedTable"] = ITEM_ALL_VALUE;
            tmpMap["selectedSmallTable"] = SMALL_ITEM_ALL_VALUE;
            tmpMap["smallTitleList"] = [initSmallTitle];

            dispatch(
              updateKeieiShindanManagerOldMap({
                keieiShindanManagerMap: tmpMap,
              })
            );
            setTmpInitTableMap(cloneMap(tmpMap));
          }
        }
      })
      .catch((r) => {
        setDialogMessage([String(r)]);
        setDialogFlg(true);
      })
      .finally(() => {
        setExecuteFlg("");
      });
  }

  // タブ内表示
  function tableResult(num: number) {
    return (
      <>
        <Grid style={{ width: "85vw" }}>
          <Grid
            container
            style={{
              padding: "10px",
            }}
          >
            <Grid item style={{ paddingRight: "15px" }}>
              <Select
                style={{
                  minWidth: 320,
                  maxWidth: 320,
                }}
                onChange={(event) => doSelChange(event)}
                value={selectedTable}
              >
                {tableList.map((rowItem) => (
                  <MenuItem value={rowItem.id}>{rowItem.name}</MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item style={{ paddingRight: "15px" }}>
              <Select
                style={{
                  minWidth: tabValue !== TAB_OFC_VALUE ? 320 : 300,
                  maxWidth: tabValue !== TAB_OFC_VALUE ? 320 : 300,
                }}
                onChange={(event) => doSmallSelChange(event)}
                value={selectedSmallTitle}
              >
                {smallTitleList.map((rowItem) => (
                  <MenuItem value={rowItem.id}>{rowItem.name}</MenuItem>
                ))}
              </Select>
            </Grid>

            <Grid item>
              <Grid container>
                <Typography>基準日：</Typography>
                <DatePicker
                  selectedDate={
                    !selectedSmallFlg ? selectedBaseDate : selectedSmallBaseDate
                  }
                  width={180}
                  dateFunc={(date: DateTime | null) => {
                    handleBaseDate(date);
                  }}
                  format={"yyyy年MM月dd日"}
                  minDate={DateTime.fromFormat("20000101", "yyyyMMdd")}
                  mainColor={"#4dc0b2"}
                />
              </Grid>
            </Grid>

            {tabValue === TAB_OFC_VALUE ? (
              <>
                <Grid item style={{ paddingRight: "10px" }}>
                  <Button
                    variant="contained"
                    color={"primary"}
                    onClick={() => moveClickDMAll()}
                  >
                    DO内個店別分析
                  </Button>
                </Grid>
              </>
            ) : (
              ""
            )}

            {(tabValue === TAB_ZO_VALUE ||
              (tabValue === TAB_DO_VALUE && workZoCode) ||
              (tabValue === TAB_OFC_VALUE && workDoCode)) &&
            (isDownloadPointData(user) ||
              (tabValue === TAB_OFC_VALUE && isDmCheck(user))) ? (
              <Grid
                container
                justify="flex-end"
                alignItems="center"
                style={{ margin: "3px" }}
              >
                <KeieiShindanStoreScoreDataButton
                  csvZoCode={tabValue === TAB_DO_VALUE ? workZoCode : ""}
                  csvDoCode={tabValue === TAB_OFC_VALUE ? workDoCode : ""}
                  addMonth={0}
                />
                <KeieiShindanStoreScoreDataButton
                  csvZoCode={tabValue === TAB_DO_VALUE ? workZoCode : ""}
                  csvDoCode={tabValue === TAB_OFC_VALUE ? workDoCode : ""}
                  addMonth={-1}
                />
              </Grid>
            ) : (
              ""
            )}
          </Grid>
          {(targetData && targetData.length > 0) ||
          (targetSmallData && targetSmallData.length > 0) ? (
            <>
              <KeieiShindanManagerAnalysisTable
                data={targetData || []}
                averageData={targetAverageData}
                headerName={headerName}
                tableHeaderList={tableHeaderList}
                tableSubmissionHeaderList={tableSubmissionHeaderList}
                tabValue={tabValue}
                graphUserList={graphUserList}
                baseMonth={!selectedSmallFlg ? baseMonth : smallBaseMonth}
                onClickMove={(code) => moveClick(code)}
                onClickSelect={(code, name) => selectClick(code, name)}
                smallFlg={selectedSmallFlg}
                smallData={targetSmallData}
                smallAverageData={targetSmallAverageData}
                bigItemId={String(Number(selectedTable) - 1)}
                smallItemId={String(Number(selectedSmallTitle) - 1)}
                selectedTable={selectedTable}
                maxScore={maxScoreDisplay}
              />
              {!selectedSmallFlg ? (
                <Grid
                  container
                  justify="center"
                  alignItems="center"
                  className={classes.graphTable}
                >
                  <ResponsiveContainer width={"100%"} height={400}>
                    <LineChart
                      data={targetGraphData}
                      margin={{ top: 5, right: 40, bottom: 60, left: 0 }}
                      stackOffset="none"
                      height={400}
                    >
                      <XAxis dataKey="month" interval={0} />
                      <YAxis domain={[0, 100]} />
                      <Tooltip />
                      <Legend verticalAlign="top" />
                      <ReferenceLine y={0} stroke="#000" />
                      {graphUserList.map((item: any) => (
                        <Line dataKey={item.name} stroke={item.fill} />
                      ))}
                    </LineChart>
                  </ResponsiveContainer>
                </Grid>
              ) : (
                ""
              )}
            </>
          ) : (
            ""
          )}
        </Grid>
      </>
    );
  }

  return (
    <Grid>
      {executeFlg === "2" ? ( // 検索中のぐるぐる表示
        <>
          <CircularProgress className={classes.circularProgress} size={120} />
          <Grid className={classes.overLayer}></Grid>
        </>
      ) : (
        ""
      )}
      <AppBar
        position="static"
        style={{
          padding: "0",
          margin: "auto",
          width: "90vw",
          outlineColor: "#3e3e3e",
          backgroundColor: "#f2f2f2",
          color: "#3e3e3e",
        }}
      >
        <Tabs
          variant="standard"
          value={indexTabValue}
          onChange={handleChange}
          aria-label="nav tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: "#37ab9d",
              height: "10px",
            },
          }}
        >
          {hasManagerAnalysisFullReferencePrivileges(user) ? (
            <Tab
              label="ZO別分析"
              disabled={executeFlg === "1" || zoTabDisableFlg}
            />
          ) : (
            ""
          )}
          {hasManagerAnalysisFullReferencePrivileges(user) ||
          isZmCheck(user) ? (
            <Tab
              label="DO別分析"
              disabled={executeFlg === "1" || doTabDisableFlg}
            />
          ) : (
            ""
          )}
          <Tab
            label="OFC別分析"
            disabled={executeFlg === "1" || ofcTabDisableFlg}
          />
          <Tab
            label="個店別分析"
            disabled={executeFlg === "1" || kobetuTabDisableFlg}
          />
        </Tabs>
      </AppBar>
      {executeFlg === "1" ? ( // 検索中のぐるぐる表示
        <>
          <Grid
            style={{
              justifyContent: "center",
              display: "flex",
            }}
          >
            <CircularProgress
              size={"40vh"}
              style={{
                color: "#ccc",
                top: "30vh",
                position: "absolute",
              }}
            />
          </Grid>
        </>
      ) : (
        <>
          {hasManagerAnalysisFullReferencePrivileges(user) ? (
            <TabPanel value={indexTabValue} index={0}>
              <Grid className={classes.root}>{tableResult(0)}</Grid>
            </TabPanel>
          ) : (
            ""
          )}
          {hasManagerAnalysisFullReferencePrivileges(user) ||
          isZmCheck(user) ? (
            <TabPanel value={tabValue} index={1}>
              <Grid className={classes.root}>{tableResult(1)}</Grid>
            </TabPanel>
          ) : (
            ""
          )}
          <TabPanel value={tabValue} index={2}>
            <Grid className={classes.root}>{tableResult(2)}</Grid>
          </TabPanel>
          <TabPanel value={tabValue} index={3}>
            <Grid className={classes.root}>{tableResult(3)}</Grid>
          </TabPanel>
        </>
      )}
      {/* ダイアログ */}
      <KeieiShindanDialog
        msg={dialogMessage}
        isOpen={dialogFlg}
        doOK={dialogClose}
        doNo={dialogClose}
        isAlert={true}
      />
    </Grid>
  );
};
export default AnalysisResult;
